$.fn.validator.Constructor.FOCUS = false;

/* === Layout cache (forced-reflow mitigation) === */
var layoutCache = { logoHeight: 0, mainnavHeight: 0, headerNavHeight: 0, winHeight: 0 };
function updateLayoutCache(){
  layoutCache.logoHeight      = $(".logo").outerHeight()      || 0;
  layoutCache.mainnavHeight   = $(".mainnav").outerHeight()   || 0;
  layoutCache.headerNavHeight = $("header nav > ul").outerHeight() || 0;
  layoutCache.winHeight       = window.innerHeight;
}
$(window).on("load resizeend orientationchange", updateLayoutCache);
$(document).ready(updateLayoutCache);
/* === /Layout cache === */


/*!	
* FitText.js 1.0 jQuery free version
*
* Copyright 2011, Dave Rupert http://daverupert.com 
* Released under the WTFPL license 
* http://sam.zoy.org/wtfpl/
* Modified by Slawomir Kolodziej http://slawekk.info
*
* Date: Tue Aug 09 2011 10:45:54 GMT+0200 (CEST)
*/
(function(){

  var addEvent = function (el, type, fn) {
    if (el.addEventListener)
      el.addEventListener(type, fn, false);
		else
			el.attachEvent('on'+type, fn);
  };
  
  var extend = function(obj,ext){
    for(var key in ext)
      if(ext.hasOwnProperty(key))
        obj[key] = ext[key];
    return obj;
  };

  window.fitText = function (el, kompressor, options) {

    var settings = extend({
      'minFontSize' : -1/0,
      'maxFontSize' : 1/0
    },options);

    var fit = function (el) {
      var compressor = kompressor || 1;

      var resizer = function () {
        el.style.fontSize = Math.max(Math.min(el.clientWidth / (compressor*10), parseFloat(settings.maxFontSize)), parseFloat(settings.minFontSize)) + 'px';
      };

      // Call once to set.
      resizer();

      // Bind events
      // If you have any js library which support Events, replace this part
      // and remove addEvent function (or use original jQuery version)
      addEvent(window, 'resize', resizer);
      addEvent(window, 'orientationchange', resizer);
    };

    if (el.length)
      for(var i=0; i<el.length; i++)
        fit(el[i]);
    else
      fit(el);

    // return set of elements
    return el;
  };
})();

/*
 Name: jQuery grouploop plugin
Verison: 1.0.3
Author: Scott Alguire
Repository: https://github.com/scottalguire/grouploop
*/
location.hash && setTimeout(function() {
    window.scrollTo(0, 0)
}, 1);
! function(a) {
    a.fn.extend({
        grouploop: function(d) {
            function f() {
                h = r / (u - 1);
                c.css("position", "relative");
                p.remove();
                p.css({
                    position: "absolute",
                    top: "0",
                    left: "0",
                    width: h,
                    height: "100%",
                    "z-index": "999"
                });
                p.prependTo(c).find(e.childWrapper)
            }

            function g() {
                e.forward ? 0 >= k ? (k += 1 * q, a(c).find(e.childWrapper).css("transform", "translateX(" + k + "px)")) : (a(c).find(e.childWrapper).css("transform", "translateX(" + -m - h + ")"), k = -m) : -m <= k ? (k -= 1 * q, a(c).find(e.childWrapper).css("transform", "translateX(" + k + "px)")) : (a(c).find(e.childWrapper).css("transform",
                    "translateX(0)"), k = 0);
                b = window.requestAnimationFrame(g)
            }
            var k, h, b, e = a.extend({
                    velocity: 2,
                    forward: !0,
                    childNode: ".item",
                    childWrapper: ".item-wrap",
                    pauseOnHover: !0,
                    complete: null,
                    stickFirstItem: !1
                }, d),
                c = this,
                m = 768 > a(window).width() ? 2 * a(window).width() : a(window).width(),
                q = e.velocity,
                r = 768 > a(window).width() ? 2 * a(c).width() : a(c).width(),
                p = a(c).find(e.childWrapper + " " + e.childNode).first(),
                u = a(c).find(e.childWrapper + " " + e.childNode).length;
            return e.stickFirstItem ? f() : h = 0, window.addEventListener("resize", function() {
                768 >
                    (m = a(window).width()) ? (console.log("Small breakpoint. Wrapper width is currently doubled."), m *= 2, r = 2 * a(c).width()) : (m = a(window).width(), r = a(c).width());
                e.stickFirstItem && f()
            }), e.forward ? (k = -m, a(c).each(function(v, l) {
                a(l).find(e.childWrapper).each(function(t, n) {
                    a(a(n).find(a(e.childNode).get().reverse())).each(function() {
                        a(this).clone().prependTo(n)
                    })
                })
            })) : (k = "none" !== a(c).find(e.childWrapper).css("transform") ? a(c).find(e.childWrapper).css("transform").split(/[()]/)[1].split(",")[4] : 0, a(c).each(function(v,
                l) {
                a(l).find(e.childWrapper).each(function(t, n) {
                    a(n).find(e.childNode).each(function() {
                        a(this).clone().appendTo(n)
                    })
                })
            })), b = window.requestAnimationFrame(g), e.pauseOnHover && a(this).hover(function() {
                cancelAnimationFrame(b)
            }, function() {
                b = window.requestAnimationFrame(g)
            }), this.each(function() {
                a.isFunction(e.complete) && e.complete.call(this)
            })
        }
    })
}(jQuery);

function showLoading(a) {
    $("#loading-wrapper").remove();
    a ? (a = $("<div>", {
        id: "loading-wrapper"
    }), $("<div>").html('<div class="fa-3x"><i class="fas fa-spinner fa-spin"></i></div>').appendTo(a), $("body").append(a)) : $("#loading-wrapper").remove()
}
var webPsupport = function() {
    var a = new Image;
    a.onload = WebP.onerror = function() {
        callback(2 == a.height)
    };
    a.src = "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA"
};
$(window).on("load", function() {
    scroll(0, 0);
    setTimeout(function() {
        scroll(0, 0)
    }, 1); 
    50 > $(window).height() - $(".logo").height() - $(".mainnav").height() - $(".sidebar.sticky").height()  && $(".sidebar").removeClass("sticky");
    if (window.location.hash || loadHash) {
        var a = window.location.hash || loadHash;
        $(a).length && setTimeout(function() {
            if($(a).hasClass('section-collapsed')){
				$(a).addClass('expand-section')
			}
			setTimeout(function(){
				$("html, body").animate({
					scrollTop: ($('body').hasClass('peaklynav-open') ? -30 : 0) + $(a).offset().top - parseInt($(a).css("padding-top")) - ($(".scroll-nav").is(":visible") ? $(".scroll-nav").height() - 15 : 0)
				}, 900, "swing")
			},700)
        }, 200)
    }
});

function customAlert(a) {
    $(".modal-body", "#alert").html(a);
    a = document.getElementById("alert");
    (new bootstrap.Modal(a, {
        keyboard: !1,
        backdrop: "static"
    })).show()
}(function(a) {
    window.alert = function() {
        return a.apply(this, arguments)
    }
})(customAlert);
(function(a, d, f, g) {
    function k(b, e) {
        this.element = b;
        this._name = "SimpleMarquee";
        this._defaults = a.fn.SimpleMarquee.defaults;
        this.settings = a.extend({}, this._defaults, e);
        this.marqueeSpawned = [];
        this.documentHasFocus = this.marqueeHovered = !1;
        this.duration = this.endPoint = this.contentWidth = this.totalDistance = this.distanceLeft = this.currentPos = this.timeLeft = this.counter = 0;
        this.hovered = !1;
        this.padding = 0;
        this.init()
    }

    function h(b) {
        this.el = b;
        this.counter = 0;
        this.name = "";
        this.duration = this.endPoint = this.contentWidth =
            this.totalDistance = this.distanceTop = this.currentPos = this.timeTop = 0;
        this.hovered = !1;
        this.padding = 0
    }
    a.extend(k.prototype, {
        init: function() {
            this.buildCache();
            this.bindEvents();
            var b = this.settings;
            0 == a(b.marquee_class).width() ? console.error("FATAL: marquee css or children css not correct. Width is either set to 0 or the element is collapsing. Make sure overflow is set on the marquee, and the children are postitioned relatively") : "undefined" === typeof a(b.marquee_class) ? console.error("FATAL: marquee class not valid") :
                "undefined" === typeof a(b.container_class) ? console.error("FATAL: marquee container class not valid") : 0 != b.sibling_class && "undefined" === typeof a(b.sibling_class) ? console.error("FATAL: sibling class container class not valid") : (b.autostart && (this.documentHasFocus = !0), this.createMarquee())
        },
        destroy: function() {
            this.unbindEvents();
            this.$element.removeData()
        },
        buildCache: function() {
            this.$element = a(this.element)
        },
        bindEvents: function() {
            var b = this;
            a(d).on("focus", function() {
                b.documentHasFocus = !0;
                for (var e in b.marqueeSpawned) b.marqueeManager(b.marqueeSpawned[e])
            });
            a(d).on("blur", function() {
                b.documentHasFocus = !1;
                for (var e in b.marqueeSpawned) b.marqueeSpawned[e].el.clearQueue().stop(), b.marqueeSpawned[e].hovered = !0
            })
        },
        unbindEvents: function() {
            a(d).off("blur focus")
        },
        getPosition: function(b) {
            return this.currentPos = parseInt(a(b).css("left"))
        },
        createMarquee: function() {
            var b = this,
                e = b.settings,
                c = a(e.marquee_class).html(),
                m = a(e.container_class).width(),
                q = a(e.marquee_class).width(),
                r = 0;
            0 != e.sibling_class && (r = a(e.sibling_class).width());
            var p = Math.ceil(m / q);
            a(e.marquee_class).remove();
            2 >= p ? p = 3 : p++;
            for (var u = -((q + e.padding) * p - m), v = m - u, l = 0; l < p; l++) {
                var t = !1;
                t = 1 == e.hover ? a('<div class="marquee-' + (l + 1) + '">' + c + "</div>").mouseenter(function() {
                    if (1 == b.documentHasFocus && 0 == b.marqueeHovered) {
                        b.marqueeHovered = !0;
                        for (var n in b.marqueeSpawned) b.marqueeSpawned[n].el.clearQueue().stop(), b.marqueeSpawned[n].hovered = !0
                    }
                }).mouseleave(function() {
                    if (1 == b.documentHasFocus && 1 == b.marqueeHovered) {
                        for (var n in b.marqueeSpawned) b.marqueeManager(b.marqueeSpawned[n]);
                        b.marqueeHovered = !1
                    }
                }) : a('<div class="marquee-' +
                    (l + 1) + '">' + c + "</div>");
                b.marqueeSpawned[l] = new h(t);
                a(e.container_class).append(t);
                b.marqueeSpawned[l].currentPos = r + q * l + e.padding * l;
                b.marqueeSpawned[l].name = ".marquee-" + (l + 1);
                b.marqueeSpawned[l].totalDistance = v;
                b.marqueeSpawned[l].containerWidth = m;
                b.marqueeSpawned[l].contentWidth = q;
                b.marqueeSpawned[l].endPoint = u;
                b.marqueeSpawned[l].duration = e.duration;
                b.marqueeSpawned[l].padding = e.padding;
                b.marqueeSpawned[l].el.css("left", b.marqueeSpawned[l].currentPos + e.padding + "px");
                1 == b.documentHasFocus && b.marqueeManager(b.marqueeSpawned[l])
            }
            f.hasFocus() ?
                b.documentHasFocus = !0 : b.documentHasFocus = !1
        },
        marqueeManager: function(b) {
            var e = b.name;
            0 == b.hovered ? 0 < b.counter ? (b.timeLeft = b.duration, b.el.css("left", b.containerWidth + "px"), b.currentPos = b.containerWidth, b.distanceLeft = b.totalDistance - (b.containerWidth - this.getPosition(e))) : b.timeLeft = (b.totalDistance - (b.containerWidth - this.getPosition(e))) / b.totalDistance * b.duration : (b.hovered = !1, b.currentPos = parseInt(b.el.css("left")), b.distanceLeft = b.totalDistance - (b.containerWidth - this.getPosition(e)), b.timeLeft =
                (b.totalDistance - (b.containerWidth - b.currentPos)) / b.totalDistance * b.duration);
            this.marqueeAnim(b)
        },
        marqueeAnim: function(b) {
            var e = this;
            b.counter++;
            b.el.clearQueue().animate({
                left: b.endPoint + "px"
            }, b.timeLeft, "linear", function() {
                e.marqueeManager(b)
            })
        },
        callback: function() {
            var b = this.settings.onComplete;
            "function" === typeof b && b.call(this.element)
        }
    });
    a.fn.SimpleMarquee = function(b) {
        this.each(function() {
            a.data(this, "plugin_SimpleMarquee") || a.data(this, "plugin_SimpleMarquee", new k(this, b))
        });
        return this
    };
    a.fn.SimpleMarquee.defaults = {
        autostart: !0,
        property: "value",
        onComplete: null,
        duration: 2E4,
        padding: 10,
        marquee_class: ".marquee",
        container_class: ".simple-marquee-container",
        sibling_class: 0,
        hover: !1
    }
})(jQuery, window, document);
var headerheight = $(window).outerHeight() - $(".logo").outerHeight();
var hasfullheightHeader = 0 < $(".fullheight").length;
if (hasfullheightHeader) {
    var marqheight = $(".simple-marquee-container").length ? $(".simple-marquee-container").outerHeight() : 0;
    window.matchMedia("(max-width: 767px)").matches && (marqheight = 0);
    headerheight = $(window).outerHeight() - marqheight
}

function shuffle(a) {
    for (var d, f, g = a.length; g; d = Math.floor(Math.random() * g), f = a[--g], a[g] = a[d], a[d] = f);
    return a
}

function recaptchaCallback() {
    $("[data-callback]").each(function(a, d) {
        a = $(this).closest("form").attr("id");
        window[a] = grecaptcha.render($(this).attr("id"), {
            sitekey: $(this).attr("data-sitekey"),
            callback: $(this).attr("data-callback")
        })
    })
}

function initZoom(a) {
    "" != $(".shop-main-img[data-big]", a) && $(".shop-main-img", a).zoom({
        url: $(".shop-main-img").attr("data-big")
    })
}

function scrollFunction(){
  // 1. ALL READS first (kein Layout zwischen ihnen)
  var scrollY = window.pageYOffset || document.documentElement.scrollTop;
  var lh = layoutCache.logoHeight;
  var mh = layoutCache.mainnavHeight;
  var hnh = layoutCache.headerNavHeight;
  var headerheight = layoutCache.winHeight - lh;

  // 2. ALL WRITES via rAF (Browser batcht den Reflow)
  requestAnimationFrame(function(){
    document.body.classList.toggle("shrink", scrollY > 150);
    $("aside > div").css({top: lh + mh + 30});
    $(".sidebar > div").css({top: lh + mh + 60});
    $("header nav > ul ul").css({paddingTop: (lh - hnh) / 2});
    $(".fullheight, .fullheight .swiper-slide").css({height: headerheight});
    $(".cart > ul > li").css({maxHeight: "calc(100vh - " + lh + "px)", overflow: "auto"});
  });
}

$(document).on("click", ".gotopw", function(a) {
    a.preventDefault();
    $("#loginmodal .swiper")[0].swiper.slideTo(1)
});
$(document).on("click", ".gotologin", function(a) {
    a.preventDefault();
    $("#loginmodal .swiper")[0].swiper.slideTo(0)
});

function initSwiper(a) {
	
    1 < $(".swiper .swiper-slide", a).length && $(".swiper:not(.swiper-yearslider)", a).each(function() {
		var d = !isNaN(Number($(this).attr("data-autoplayx"))) && 0 < Number($(this).attr("data-autoplayx")) ? {
                delay: Number($(this).attr("data-autoplayx")),
                disableOnInteraction: !0
            } : !1,
            f = void 0 != $(this).attr("data-left") && "" != $(this).attr("data-left") ? $(this).attr("data-left") : $(".swiper-button-prev", this)[0],
            g = void 0 != $(this).attr("data-right") && "" != $(this).attr("data-right") ? $(this).attr("data-right") :
            $(".swiper-button-next", this)[0],
            k = void 0 != $(this).attr("data-autoheightx") ? "true" === $(this).attr("data-autoheightx") : !0,
            h = {};
        "creative1" == $(this).attr("data-effectx") ? h = {
                prev: {
                    shadow: !0,
                    origin: "left center",
                    translate: ["-5%", 0, -200],
                    rotate: [0, 100, 0]
                },
                next: {
                    origin: "right center",
                    translate: ["5%", 0, -200],
                    rotate: [0, -100, 0]
                }
            } : "creative2" == $(this).attr("data-effectx") ? h = {
                prev: {
                    shadow: !0,
                    translate: ["-125%", 0, -800],
                    rotate: [0, 0, -90]
                },
                next: {
                    shadow: !0,
                    translate: ["125%", 0, -800],
                    rotate: [0, 0, 90]
                }
            } : "creative3" ==
            $(this).attr("data-effectx") && (h = {
                prev: {
                    shadow: !0,
                    translate: [0, 0, -400]
                },
                next: {
                    translate: ["100%", 0, 0]
                }
            });
			var xs = Number($(this).attr("data-itemsx-xs"));
			var sm = Number($(this).attr("data-itemsx-sm"));
			var md = Number($(this).attr("data-itemsx-md"));
			var lg = Number($(this).attr("data-itemsx-lg"));
			var xl = Number($(this).attr("data-itemsx"));
			
			var centered = $(this).attr("data-centeredx") == 'true' ? true : false;
			var centeredInsufficient = $(this).attr("data-centeredInsufficientx") == 'true' ? true : false;
			var allowSwipeMobile = $(this).attr("data-swipe") == 'true' ? true : false;
			var freemode = $(this).attr("data-freex") == 'true' ? true : false;
			var vertical = $(this).attr("data-directionx");
			var spaceBetween = isNaN($(this).attr("data-spacebetweenx")) ? 0 : parseInt($(this).attr("data-spacebetweenx"));
			var shadowx = $(this).attr("data-shadowx") == 'true' ? true : false;
			var paginationTarget = $(this).attr("data-pagination-target") != undefined ? $(this).attr("data-pagination-target") : '';
			//var arrowNavTarget = $(this).attr("data-arrows-target") != undefined ? $(this).attr("data-arrows-target") : '';
		
        new Swiper(this, {
            direction: vertical == 'vertical' ? 'vertical' : 'horizontal',
            loop: "true" == $(this).attr("data-loopx") ? !0 : !1,
            autoHeight: vertical == 'vertical' ? true : k,
			allowTouchMove: allowSwipeMobile ? true : false,
            initialSlide: isNaN($(this).attr("data-initial")) ? 0 : Number($(this).attr("data-initial")),
            speed: Number($(this).attr("data-speedx")),
            effect: -1 == $(this).attr("data-effectx").indexOf("creative") ? $(this).attr("data-effectx") : "creative",
            slidesPerView: $(this).attr("data-itemsx"),
            loopedSlides: isNaN($(this).attr("data-itemsx")) ?
                null : Number($(this).attr("data-itemsx")), 
           // spaceBetween: 15,
			centeredSlides: centered,
            observer: !0,
			freeMode: freemode,
            simulateTouch: true,
			centerInsufficientSlides: centeredInsufficient,
            passiveListeners: !1,
            observeParents: !0,
			clickable:true,
            fadeEffect: {
                crossFade: !0
            },
            coverflowEffect: {
                rotate: 0,
                depth: 130,
                slideShadows: shadowx
            },
            creativeEffect: h,
            autoplay: d,
            pagination: {
                el: paginationTarget != '' ? paginationTarget : $(".swiper-pagination", this)[0],
                type: "bullets",
                clickable: !0
            },
            navigation: {
                nextEl: g,
                prevEl: f,
                hideOnClick: !1
            },
            scrollbar: {
                el: $(".swiper-scrollbar", this)[0],
                draggable: !1
            },
            watchSlidesProgress: !0,
            renderProgressbar: function(b) {
                return '<span class="' + b + '"></span>'
            },
            lazy: {
                loadPrevNext: !0,
                loadPrevNextAmount: 10
            },
            breakpoints: {
                0: {
                    slidesPerView: !isNaN(xs) ? xs : 1,
                    spaceBetween: spaceBetween
                },
                575: {
                    slidesPerView: !isNaN(sm) ? sm : 1,
                    spaceBetween: spaceBetween
                },
                768: {
                    slidesPerView: !isNaN(sm) ? md : 1,
                    spaceBetween: spaceBetween
                },
                992: {
                    slidesPerView: !isNaN(lg) ? lg : 1,
                    spaceBetween: spaceBetween
                },
				1140: {
                    slidesPerView: !isNaN(xl) ? xl : 1,
                    spaceBetween: isNaN(xl) || xl == 1 ? 0 : spaceBetween
                }
            },
			//init:false,
			on: {
				init: function(swiper){
				
				  console.log(swiper)
				  swiper['$el'][0].classList.add("is-ready");
				},
				slideChangeTransitionEnd: function(b) {},
				lazyImageReady: function(b) {
					b.update()  
				},  
				breakpoint: function(swiper, breakpointParams) {
					setTimeout(function(){
						if(!$(swiper.el).hasClass('swiper-vertical')){
							if($(swiper.el).find('.swiper-pagination-lock').length && $(swiper.el).find('.swiper-pagination-bullet-active:visible').length){
								$('>.swiper-wrapper:not(.owww)',swiper.el).removeClass('pb-5').addClass('pb-5');
							
							}
							else if($(swiper.el).find('.swiper-pagination-bullet-active:visible').length){
								
								$('>.swiper-wrapper:not(.owww)',swiper.el).removeClass('pb-4 pb-5').addClass('pb-5');
							}
							else if(!$(swiper.el).find('.swiper-pagination-bullet-active:visible').length){
								
								$('>.swiper-wrapper:not(.owww)',swiper.el).removeClass('pb-6 pb-4 pb-5');
							}
						}
					},10)  
				},
			}
		})
    })
}

function initSwiper2(a) {

	/* CML: guard - only init if there is at least 2 slides in the given scope */
	if ($(".swiper .swiper-slide", a).length <= 1) return;

	/* CML: helpers */
	function toBool(v, defVal) {
		if (v === undefined || v === null || v === "") return !!defVal;
		return String(v).toLowerCase() === "true";
	}

	function toInt(v, defVal) {
		var n = parseInt(v, 10);
		return isNaN(n) ? defVal : n;
	}

	function toNum(v, defVal) {
		var n = Number(v);
		return isNaN(n) ? defVal : n;
	}

	function clampInt(n, minV, maxV, defVal) {
		var x = parseInt(n, 10);
		if (isNaN(x)) x = defVal;
		if (x < minV) x = minV;
		if (x > maxV) x = maxV;
		return x;
	}

	function getElInContext($sw, selectorOrEl) {
		/* CML: if element is passed, return as-is */
		if (selectorOrEl && (selectorOrEl.nodeType === 1 || selectorOrEl === window || selectorOrEl === document)) return selectorOrEl;

		/* CML: if string selector passed, prefer lookup inside swiper first */
		if (typeof selectorOrEl === "string" && selectorOrEl !== "") {
			var inSw = $(selectorOrEl, $sw[0])[0];
			if (inSw) return inSw;
			var global = $(selectorOrEl)[0];
			if (global) return global;
		}
		return null;
	}

	function getNavEl($sw, attrName, fallbackSelector) {
		var v = $sw.attr(attrName);
		if (v !== undefined && v !== null && v !== "") {
			return getElInContext($sw, v) || v; /* keep original value if swiper can resolve */
		}
		return $(fallbackSelector, $sw[0])[0];
	}

	function buildAutoplay(ms) {
		if (!isNaN(ms) && ms > 0) return { delay: ms, disableOnInteraction: !0 };
		return !1;
	}

	function buildCreativeEffect(effectName) {
		var h = {};
		if (effectName == "creative1") {
			h = {
				prev: { shadow: !0, origin: "left center", translate: ["-5%", 0, -200], rotate: [0, 100, 0] },
				next: { origin: "right center", translate: ["5%", 0, -200], rotate: [0, -100, 0] }
			};
		} else if (effectName == "creative2") {
			h = {
				prev: { shadow: !0, translate: ["-125%", 0, -800], rotate: [0, 0, -90] },
				next: { shadow: !0, translate: ["125%", 0, -800], rotate: [0, 0, 90] }
			};
		} else if (effectName == "creative3") {
			h = {
				prev: { shadow: !0, translate: [0, 0, -400] },
				next: { translate: ["100%", 0, 0] }
			};
		}
		return h;
	}

	function computeWrapperPadding(sw) {
		/* CML: replicate old behavior but without expensive :visible queries */
		if ($(sw.el).hasClass("swiper-vertical")) return;

		var $el = $(sw.el);
		var $wrap = $(">.swiper-wrapper:not(.owww)", sw.el);

		var hasPagination = !!(sw.pagination && sw.pagination.el);
		var locked = hasPagination && $(sw.pagination.el).hasClass("swiper-pagination-lock");

		if (hasPagination && !locked) {
			$wrap.removeClass("pb-4 pb-5 pb-6").addClass("pb-5");
		} else {
			$wrap.removeClass("pb-6 pb-4 pb-5");
		}
	}

	/* CML: init each swiper in scope */
	$(".swiper:not(.swiper-yearslider)", a).each(function() {

		var el = this;
		var $sw = $(el);

		/* CML: prevent double init; if already initialized just update */
		if (el.swiper) {
			try { el.swiper.update(); } catch (e) {}
			return;
		}

		/* CML: mark pre-init (optional CSS can hide until ready) */
		$sw.addClass("is-preinit");

		/* CML: prefer dataset (faster, cleaner) */
		var ds = el.dataset || {};

		var effectx = ds.effectx || $sw.attr("data-effectx") || "slide";
		var directionx = (ds.directionx || $sw.attr("data-directionx")) == "vertical" ? "vertical" : "horizontal";

		var xs = toNum(ds.itemsxXs || $sw.attr("data-itemsx-xs"), NaN);
		var sm = toNum(ds.itemsxSm || $sw.attr("data-itemsx-sm"), NaN);
		var md = toNum(ds.itemsxMd || $sw.attr("data-itemsx-md"), NaN);
		var lg = toNum(ds.itemsxLg || $sw.attr("data-itemsx-lg"), NaN);
		var xl = toNum(ds.itemsx || $sw.attr("data-itemsx"), NaN);

		var centered = toBool(ds.centeredx || $sw.attr("data-centeredx"), !1);
		var centeredInsufficient = toBool(ds.centeredinsufficientx || $sw.attr("data-centeredInsufficientx"), !1);
		var allowSwipe = toBool(ds.swipe || $sw.attr("data-swipe"), !1);
		var freemode = toBool(ds.freex || $sw.attr("data-freex"), !1);

		var loopx = toBool(ds.loopx || $sw.attr("data-loopx"), !1);

		/* CML: autoheight default true, if attribute exists respect it */
		var autoHeightx = !0;
		if ($sw.attr("data-autoheightx") !== undefined || ds.autoheightx !== undefined) {
			autoHeightx = toBool(ds.autoheightx || $sw.attr("data-autoheightx"), !0);
		}

		var spaceBetween = toInt(ds.spacebetweenx || $sw.attr("data-spacebetweenx"), 0);
		if (spaceBetween < 0) spaceBetween = 0;

		var shadowx = toBool(ds.shadowx || $sw.attr("data-shadowx"), !1);

		var paginationTarget = ds.paginationTarget || $sw.attr("data-pagination-target");
		paginationTarget = (paginationTarget !== undefined && paginationTarget !== null) ? paginationTarget : "";

		var initialSlide = toInt(ds.initial || $sw.attr("data-initial"), 0);

		/* CML: keep 0 as valid speed */
		var speedRaw = (ds.speedx !== undefined) ? ds.speedx : $sw.attr("data-speedx");
		var speedx = toInt(speedRaw, 300);
		if (speedRaw !== undefined && speedRaw !== null && speedRaw !== "" && !isNaN(Number(speedRaw))) speedx = Number(speedRaw);

		var autoplayMs = toNum(ds.autoplayx || $sw.attr("data-autoplayx"), 0);
		var autoplay = buildAutoplay(autoplayMs);

		var prevEl = getNavEl($sw, "data-left", ".swiper-button-prev");
		var nextEl = getNavEl($sw, "data-right", ".swiper-button-next");

		var creativeEffect = buildCreativeEffect(effectx);
		var finalEffect = (String(effectx).indexOf("creative") === -1) ? effectx : "creative";

		/* CML: slides count and smart loopedSlides */
		var slideCount = $sw.find(".swiper-slide").length;

		var rootSlidesPerView = (!isNaN(xl) && xl > 0) ? xl : 1;

		var rootLoopedSlides = null;
		if (loopx) {
			var base = rootSlidesPerView;
			var proposed = base * 2;
			if (proposed < base + 1) proposed = base + 1;
			if (proposed > slideCount) proposed = slideCount;
			rootLoopedSlides = proposed;
		}

		/* CML: debounce for lazy updates */
		var lazyT = null;
		function scheduleUpdate(sw) {
			clearTimeout(lazyT);
			lazyT = setTimeout(function() {
				try { sw.update(); } catch (e) {}
			}, 50);
		}

		/* CML: resolve pagination element */
		var paginationEl = null;
		if (paginationTarget && paginationTarget !== "") {
			paginationEl = getElInContext($sw, paginationTarget) || paginationTarget;
		} else {
			paginationEl = $(".swiper-pagination", el)[0];
		}

		/* CML: resolve scrollbar element */
		var scrollbarEl = $(".swiper-scrollbar", el)[0];

		/* CML: build swiper */
		var swiper = new Swiper(el, {
			init: !1,

			direction: directionx,
			loop: loopx,
			autoHeight: (directionx == "vertical") ? !0 : autoHeightx,

			/* CML: allowTouchMove can be overridden via breakpoints below */
			allowTouchMove: allowSwipe,
			simulateTouch: !0,

			initialSlide: initialSlide,
			speed: speedx,

			effect: finalEffect,
			slidesPerView: rootSlidesPerView,
			loopedSlides: rootLoopedSlides,

			centeredSlides: centered,
			centerInsufficientSlides: centeredInsufficient,

			observer: !0,
			observeParents: !0,
			passiveListeners: !1,

			freeMode: freemode,

			fadeEffect: { crossFade: !0 },
			coverflowEffect: { rotate: 0, depth: 130, slideShadows: shadowx },
			creativeEffect: creativeEffect,

			autoplay: autoplay,

			pagination: {
				el: paginationEl,
				type: "bullets",
				clickable: !0
			},
			navigation: {
				nextEl: nextEl,
				prevEl: prevEl,
				hideOnClick: !1
			},
			scrollbar: {
				el: scrollbarEl,
				draggable: !1
			},

			watchSlidesProgress: !0,
			renderProgressbar: function(b) { return '<span class="' + b + '"></span>'; },

			lazy: {
				loadPrevNext: !0,
				loadPrevNextAmount: 10
			},

			/* CML: Bootstrap 4 breakpoints (exact) */
			breakpoints: {
				0: {
					slidesPerView: (!isNaN(xs) && xs > 0) ? xs : 1,
					spaceBetween: spaceBetween
				},
				576: {
					slidesPerView: (!isNaN(sm) && sm > 0) ? sm : 1,
					spaceBetween: spaceBetween
				},
				768: {
					slidesPerView: (!isNaN(md) && md > 0) ? md : 1,
					spaceBetween: spaceBetween
				},
				992: {
					slidesPerView: (!isNaN(lg) && lg > 0) ? lg : 1,
					spaceBetween: spaceBetween
				},
				1200: {
					slidesPerView: (!isNaN(xl) && xl > 0) ? xl : 1,
					spaceBetween: (isNaN(xl) || xl == 1) ? 0 : spaceBetween
				}
			},

			on: {
				init: function(sw) {
					sw.$el[0].classList.remove("is-preinit");
					sw.$el[0].classList.add("is-ready");
					computeWrapperPadding(sw);
				},
				slideChangeTransitionEnd: function(b) {},
				lazyImageReady: function(sw) {
					scheduleUpdate(sw);
				},
				breakpoint: function(sw, bp) {
					setTimeout(function() {
						computeWrapperPadding(sw);
					}, 10);
				}
			}
		});

		/* CML: init on next paint */
		requestAnimationFrame(function() {
			swiper.init();
		});
	});
}


$("#serpmodal").on("shown.bs.modal", function(a) {
    var d = $("title").first().text(), 
        f = $('meta[name="description"]').first().prop("content");
    a = window.location.href.replace("https://", "");
    $("#serpmodal .metatitle").text(d).attr("href", a);
    $("#serpmodal .metadesc").text(f);
    $("#serpmodal .metaurl").text(a);
    d = $('meta[property="og:title"]').first().attr("content");
    f = $('meta[property="og:description"]').first().attr("content");
    var g = $('meta[property="og:image"]').first().attr("content");
    $("#serpmodal .ogtitle").text(d);
    $("#serpmodal .ogdesc").text(f);
    $("#serpmodal .ogurl").attr("href", a).text(a);
    $("#serpmodal .ogimg").attr("src", g + "?_cache=" + (new Date).getTime()) 
});
$("#cartmodal").on("hidden.bs.modal", function(a) {
    $("#cartmodal > div").html("")
});
$("#modal").on("shown.bs.modal", function(a) {
    $("#modal").attr("data-header", $(a.relatedTarget).attr("data-modal-header"));
    setTimeout(function() {
        $(".shop-main-img").length && "" != $(".shop-main-img").attr("data-big").trim() && initZoom("body");
        $(".fullheight,.fullheight > .swiper-slide", "#modal").height($("#modal .modal-content").height());
        initSwiper2("#modal");
        $("[data-a]", "#modal").each(function() {
            "email" == $(this).text() && $(this).text($(this).attr("data-a") + "@" + $(this).attr("data-d"));
            $(this).attr("href",
                "mailto:" + $(this).attr("data-a") + "@" + $(this).attr("data-d"))
        });
        $(".form", "#modal").length && ($(".form", "#modal").validator(), 0 < $("#modal #recaptcha").length && grecaptcha.render("recaptcha", {
            sitekey: "6Lc5XtQZAAAAAFQR1ZGze4BPSG_i2xBXgvwKqbtV",
            hl: langdouble
        }), 0 < $("#modal .datepicker").length || 0 < $("#modal .timepicker").length || 0 < $("#modal .datetimepicker").length) && ($(".datepicker", "#modal").datetimepicker({
            useCurrent: !1,
            format: "L",
            locale: langdouble,
            showTodayButton: !0,
            icons: {
                next: "fa fa-chevron-right",
                previous: "fa fa-chevron-left",
                today: "todayText"
            }
        }), mdtimepicker("#modal .timepicker", {
            format: "hh:mm",
            is24hour: !0,
            theme: "yellow",
            minTime: "6:00",
            maxTime: "22:00"
        }), $(".datetimepicker", "#modal").datetimepicker({
            format: "L",
            locale: langdouble,
            icons: {
                up: "fa fa-chevron-up",
                down: "fa fa-chevron-down"
            }
        }))
		//manager.run(iframeConfig)
		
		
		
		
    }, 400)
});
$("#modal").on("hidden.bs.modal", function(a) {
	$('.modal-body',this).html('')	
});

$("section a.gallery").each(function(){
	$(this).simpleLightbox({
		navText: ["&lsaquo;", "&rsaquo;"],
		overlayOpacity: 1,
		history: false,
		captionSelector: "self"
	});	
})

$(".photos a").each(function(){
	$(this).simpleLightbox({
		navText: ["&lsaquo;", "&rsaquo;"],
		overlayOpacity: 1,
		history: false,
		captionSelector: "self"
	});	
})
/*var gallery = $(".photos a").simpleLightbox({
    navText: ["&lsaquo;", "&rsaquo;"],
    overlayOpacity: 1,
    history: false,
    captionSelector: "self"
});*/
$("body").on("click", '[data-toggle="modal"][data-target="#modal"][data-remote]', function(a) {
    $($(this).data("target") + " .modal-body").html('<div class="fa-1x"><i class="fas fa-spinner fa-spin"></i></div>')
	
	$($(this).data("target") + " .modal-body").load($(this).data("remote").split(' ')[0] + "?ajax=" + $("main section").length + $(this).data("remote").split(' ')[1], function(response, status, xhr) {

		/* $('#modal[data-header="false"]').length && $("<i>", {
            class: "fas fa-times-circle position-absolute",
            style: "z-index:9999;cursor:pointer;right:30px;top:20px;"
        }).appendTo("#modal .modal-body");*/
        
		$('#modal section').each(function(i,e){
			$(this).attr('id',$(this).attr('id')+'modal');	
		})
		
		$('#modal .sticky').attr('style','position:sticky !important;top:0;');
		$('#modal .expandNextSection,#modal .showhiddentext').hide()
		$('#modal [data-parallax="scroll"]').html('<img width="100%" src="'+$('#modal [data-parallax="scroll"]').attr('data-image-src')+'"/>')
		
	    $("#modal .modal-dialog").removeClass('modal-lg modal-sm').addClass('modal-xl')
		//$("#modal .modal-body").find("section").removeAttr("id");
		$("#modal").find(".off").removeClass("off");
        $(document).on("click", "#modal .fa-times-circle", function() {
            $("#modal").modal("hide")
        })
    })
});



$("body").on("click", '[data-toggle="modal"][data-remote-modal]', function () {
	
	function appendAjaxParam(rawUrl) {
		let parts = rawUrl.trim().split(/(?=\s)/); // trennt bei erstem Whitespace (z.â€¯B. "/zielseite.html/ main")
		let baseUrl = parts[0];
		let selector = parts.slice(1).join(' '); // Rest als "Selektor"
	
		const ajaxVal = $("main section").length;
		const separator = baseUrl.includes('?') ? '&' : '?';
		const patchedUrl = `${baseUrl}${separator}ajax=${ajaxVal}`;
	
		return patchedUrl + (selector ? ' ' + selector : '');
	}

	const target = $(this).data("target");
	const modalBody = $(target).find(".modal-body");
	const remoteUrl = appendAjaxParam($(this).data("remote-modal").split(' ')[0]);

	modalBody.html(`
	  <div style="
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		min-height: 200px;
	  ">
		<i class="fas fa-spinner fa-spin" style="font-size: 3rem; color: #6c757d;"></i>
	  </div>
	`);
	
	$.get(remoteUrl, function(response) {
		const tempDom = $('<div>').append($.parseHTML(response));

		// â¬‡ï¸ Load and inject styles (if not already present)
		tempDom.find('link[rel="stylesheet"], style').each(function() {
			let $el = $(this);
			if ($el.is('link') && !$(`link[href="${$el.attr('href')}"]`).length) {
				$('head').append($el.clone());
			} else if ($el.is('style') && !$(`#${$el.attr('id')}`).length) {
				$('head').append($el.clone());
			}
		});

		// â¬‡ï¸ Load and run scripts (if not already present)
		tempDom.find('script').each(function () {
			const $script = $(this);
			const type = ($script.attr('type') || '').toLowerCase();
		
			// ðŸš« Skip template and JSON-LD scripts
			if (type === 'text/template' || type === 'application/ld+json') return;
		
			const newScript = document.createElement('script');
		
			if ($script.attr('src')) {
				const src = $script.attr('src');
				if (!$(`script[src="${src}"]`).length) {
					newScript.src = src;
					document.head.appendChild(newScript);
				}
			} else {
				newScript.text = $script.html();
				document.body.appendChild(newScript);
			}
		});


		// â¬‡ï¸ Only inject <main> content into modal
		const mainContent = tempDom.find("main").html() || "<p class='text-danger'>Kein Inhalt verfÃ¼gbar.</p>";
				
		modalBody.html(`<div style="display:none">${mainContent}</div>`);
		
		/*modalBody.find("section").each(function () {
			$(this).css("height", "auto");
		});*/
		
		$('#modal section').each(function(i,e){
			$(this).attr('id',$(this).attr('id')+'modal');	
		})
		
		$('#modal .sticky').attr('style','position:sticky !important;top:0;');
		$('#modal .expandNextSection,#modal .showhiddentext').hide()
		$('#modal [data-parallax="scroll"]').html('<img width="100%" src="'+$('#modal [data-parallax="scroll"]').attr('data-image-src')+'"/>')
		
	    $("#modal .modal-dialog").removeClass('modal-lg modal-sm').addClass('modal-xl')
		//$("#modal .modal-body").find("section").removeAttr("id");
		$("#modal").find(".off").removeClass("off");
        $(document).on("click", "#modal .fa-times-circle", function() {
            $("#modal").modal("hide")
        })
		
		setTimeout(function () {
			modalBody.children(":first").fadeIn('slow');
		}, 600);
		
	});
});

$("body").on("click", '[rel="modal"]', function(a) {
    a.preventDefault();
    $("#modal .modal-body").load($(this).attr("href") + " main", function() {
        $("#modal").find(".off").removeClass("off")
    });
    $("#modal").modal("show")
});
$(".full,.fullheight,.fullheight .swiper-slide").css({
    height: headerheight
});
$(window).on("load", function() {
    /*$(".mainnav").css({
        top: $(".logo").outerHeight()
    });*/
    $("aside > div").css({
        top: $(".logo").outerHeight() + $(".mainnav").outerHeight() + 30
    });
    $(".sidebar > div").css({
        top: $(".logo").outerHeight() + $(".mainnav").outerHeight() + 60
    });
    $("body").css({});
    $("header nav > ul ul").css({});
    setTimeout(function() {
        $(window).trigger("resize");
        0 < $("section[data-vide-bg]").length && $("section[data-vide-bg]").data("vide").getVideoObject().play()
    }, 300);
    if ($(".scroll-nav ul").length) {
        var a = 0,
            d = "";
        $(window).on("activate.bs.scrollspy", function(k, h) {
			var activeLink = document.querySelector(".scroll-nav-link.active");
			var navUl = document.querySelector(".scroll-nav ul");
			if (!activeLink || !navUl) return;
		
			// ALL READS first
			var linkRect = activeLink.getBoundingClientRect();
			var navRect = navUl.getBoundingClientRect();
			var navWidth = navRect.width; // bereits aus getBoundingClientRect verfügbar
			var inView = (linkRect.left <= navRect.left)
				? (navRect.left - linkRect.left <= linkRect.width)
				: (linkRect.right - navRect.right <= linkRect.width);
		
			if (inView) return;
		
			// ALL WRITES via rAF
			var delta = (d === "down") ? navWidth : -navWidth;
			requestAnimationFrame(function(){
				navUl.scrollLeft += delta;
			});
		});
    }
   // $(window).scroll(function() {
//        //$("#sidecontact-close:not(.closed)").addClass("closed").trigger("click");
//        var k = window.pageYOffset || document.documentElement.scrollTop;
//        d = k > a ? "down" : "up";
//        a = 0 >= k ? 0 : k;
//        $(".fadeInBlock").each(function(h) {
//            h = $(this).offset().top;
//            var b = $(window).scrollTop();
//            b += $(window).height() / 1.3;
//            b > h && ($(this).animate({
//                opacity: 1
//            }, 550), $(this).removeClass("fadeInBlock"))
//        })
//		
//		$(".animateInBlock").each(function(h) {
//            h = $(this).offset().top;
//            var b = $(window).scrollTop();
//            b += $(window).height() / 1.3;
//            b > h && $(this).removeClass('hidden').addClass($(this).attr('data-animationin')) 
//        })	
//    });


	var fadeObserver = new IntersectionObserver(function(entries){
	entries.forEach(function(entry){
	  if (entry.isIntersecting) {
		var $el = $(entry.target);
		if ($el.hasClass("fadeInBlock")) {
		  $el.animate({opacity: 1}, 800).removeClass("fadeInBlock");
		}
		if ($el.hasClass("animateInBlock")) {
		  $el.addClass("animated").removeClass("animateInBlock");
		}
		fadeObserver.unobserve(entry.target);
	  }
	});
	}, { rootMargin: "0px 0px -23% 0px" }); // ~ entspricht height/1.3-Trigger
	
	document.querySelectorAll(".fadeInBlock, .animateInBlock").forEach(function(el){
	fadeObserver.observe(el);
	});


    $("body").scrollspy({
        target: ".scroll-nav",
        offset: $(".logo").outerHeight() + $(".mainnav").outerHeight()
    });
    if ("Yes" == popup && 0 <= popupidle) {
        var f, g;
        $(document).idle({
            onIdle: function() {
                f = new Date;
                2 == popupstyle ? $("#modal").addClass("modal-fullscreen") :
                    $("#modal").removeClass("modal-fullscreen");
                $("#modal").modal("show")
				$(document).trigger('idle:stop')
            },
            onHide: function() {
                g = new Date
            },
            onShow: function() {
                //Math.ceil(((new Date).getTime() - g.getTime()) / 1E3) > popupidle && (showToast("Wieder da?", Math.ceil(((new Date).getTime() - g.getTime()) / 6E4) + " Min.", "Das freut uns sehr, dass Sie uns nicht vergessen hab en!"), g = null)
            },
            onActive: function() {
                
				//Math.ceil(((new Date).getTime() - f.getTime()) / 1E3) > popupidle && (showToast("Immer noch da?", Math.ceil(((new Date).getTime() - f.getTime()) / 6E4) + " Min.", "Das freut uns sehr. Unser Inhalt scheint interessant f\u00fcr Sie zu sein"), f = null)
            },
            idle: 1000 * popupidle,
            recurIdleCall: false
        });
        po = 0;
		
    }
    "Yes" == popup && 1 <= po && (1 == po && popupdelay == 0 ? $("#modal").modal("show") : popupdelay == 0 && void 0 == Cookies.get("csl" + pid) && ($("#modal").modal("show"), $("#modal").on("hidden.bs.modal", function(k) {
        4 == po ? $('#modal [type="checkbox"]').is(":checked") && Cookies.set("csl" + pid, "shown", {
            expires: 30,
            path: window.location.pathname
        }) : 2 == po && Cookies.set("csl" + pid, "shown", {
            expires: 30,
            path: window.location.pathname
        })
    })));
	
	if(popup == "Yes" && popupdelay > 0){
		setTimeout(function(){
			$("#modal").modal("show");
			$("#modal").on("hidden.bs.modal", function(k) {
				4 == po ? $('#modal [type="checkbox"]').is(":checked") && Cookies.set("csl" + pid, "shown", {
					expires: 30,
					path: window.location.pathname
				}) : 2 == po && Cookies.set("csl" + pid, "shown", {
					expires: 30,
					path: window.location.pathname
				})
			});
		},popupdelay*1000)	
	}
	
    $(".shop-main-img").length && "" != $(".shop-main-img").attr("data-big").trim() && initZoom("body");
    initSwiper2("body")
});

$('form[data-toggle="validator"]').length && (window.matchMedia("(max-width: 767px)").matches ? $.fn.validator.Constructor.FOCUS_OFFSET = 120 : $.fn.validator.Constructor.FOCUS_OFFSET = 320);
$(window).resize(function() {
   /* 0 < $(".fullheight").length && (headerheight = $(window).outerHeight() - marqheight, $(".full,.fullheight,.fullheight .swiper-slide").css({
        height: headerheight
    }));
    $(".cart > ul > li").css({
        maxHeight: "calc(100vh - " + $(".logo").height() + "px)",
        overflow: "hidden",
        overflowY: "auto"
    });
    window.matchMedia("(max-width: 767px)").matches ? $.fn.validator.Constructor.FOCUS_OFFSET = 120 : $.fn.validator.Constructor.FOCUS_OFFSET = 320;
    $(".floating-sidebar").length ? window.matchMedia("(max-width: 767px)").matches ?
        $(".floating-sidebar").addClass("last") : $("section").not(":hidden").last().addClass("last") : $("section").not(":hidden").last().addClass("last");
		//document.documentElement.style.setProperty('--viewport-height', $(window).outerHeight() + 'px'); 
		
	if($(".floating-sidebar:visible").length){
		//$(".floating-sidebar").css({top:$('[data-startfloatingsection] > div').offset().top, height:($('[data-endfloatingsection]').position().top + parseInt($('[data-endfloatingsection]').css('height')) - parseInt($('[data-endfloatingsection]').css('padding-top')) - parseInt($('[data-endfloatingsection]').css('padding-bottom')) + parseInt($('[data-endfloatingsection] .textoverlap').css('top'))) - $('[data-startfloatingsection]').position().top,left:'auto'})
		var xstyle1 = 'top:'+$('[data-startfloatingsection] > div').offset().top+'px !important;';
		var xstyle2 = 'height:'+$('[data-endfloatingsection]').position().top + parseInt($('[data-endfloatingsection]').css('height')) - parseInt($('[data-endfloatingsection]').css('padding-top')) - parseInt($('[data-endfloatingsection]').css('padding-bottom')) + parseInt($('[data-endfloatingsection] .textoverlap').css('top')) - $('[data-startfloatingsection]').position().top + 'px !important;';
		var xstyle3 = 'left:auto;';
		console.log(xstyle2)
		$(".floating-sidebar").attr('style',xstyle1+xstyle2+xstyle3)
	}*/
		
});
//document.documentElement.style.setProperty('--viewport-height', $(window).outerHeight() + 'px');
function spamproofemail(){
    $("[data-a]").each(function() {
        var email = $(this).attr("data-a") + "@" + $(this).attr("data-d");
        var text = $(this).text() == "email" ? email : $(this).text();
        
        if(!$(this).is("a")) {
            var $a = $("<a>").attr("href", "mailto:" + email).text(text);
            $(this).replaceWith($a);
        } else {
            $(this).text(text).attr("href", "mailto:" + email);
        }
    });
}
spamproofemail()
$( document ).ajaxComplete(function() {
  spamproofemail()
});
$(document).on("click", ".thumb", function() {
    $(".big").attr("src", $(this).attr("src"));
    $(".shop-main-img").trigger("zoom.destroy");
    var a = $(this).attr("src").replace($(this).attr("src").split("/")[$(this).attr("src").split("/").length - 1], "zoom_" + $(this).attr("src").split("/")[$(this).attr("src").split("/").length - 1]) + "?_cache=" + (new Date).getTime();
    $.ajax({
        url: a,
        crossDomain: !0,
        success: function(d) {
            $(".shop-main-img").attr("data-big", $(".big").attr("src").replace($(".big").attr("src").split("/")[$(".big").attr("src").split("/").length -
                1], "zoom_" + $(".big").attr("src").split("/")[$(".big").attr("src").split("/").length - 1]) + "?_cache=" + (new Date).getTime());
            initZoom("body")
        }
    })
});
$(document).on("click", 'a[href*="#"]', function(a) {
    var d = "html, body";
	var o = !isNaN($(this).attr('data-offset')) ? parseInt($(this).attr('data-offset')) : 0;
    0 < $(a.target).closest(".modal").length && (d = ".modal-body");
  
    if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
        var f = $(this.hash, d);
        f = f.length ? f : $("[name=" + this.hash.slice(1) + "]");
		
        if (f.length) {
			
            a.preventDefault();
            var g = 0;
            $("body").hasClass("shrink") || (g = 0);
            f = f.offset().top - o;
            0 < $(a.target).closest(".modal").length && (g = $(".modal-body main section").first().height() + 120, f = $("#modal form").position().top);
            a = 0;
            $(".mainnav").is(":visible") || (a = 0);
			if($(this.hash, d).hasClass('section-collapsed')){
				$(this.hash, d).addClass('expand-section')
			}
			$(d).animate({
				scrollTop: ($('body').hasClass('peaklynav-open') && $('#peaklynav').hasClass('top') ? -94 : 0) + f - ($(".logo").outerHeight() + a - g - 5 + o)
			}, 700)	
			console.log()
			
            
        }
    }
});
$(".shape-divider").each(function() {
    var a = $(this),
        d = a.attr("data-shape") || "valley",
        f = a.attr("data-width") || 100,
        g = a.attr("data-height") || 100,
        k = a.attr("data-fill"),
        h = a.attr("data-outside") || "false",
        b = a.attr("data-position") || "top",
        e = "shape-divider-" + Math.floor(1E4 * Math.random()),
        c = "";
    c = "";
    100 > f && (f = 100);
    f = "width: calc( " + Number(f) + "% + 1.5px );";
    var m = "height: " + Number(g) + "px;";
    "true" == h && (c = "bottom" == b ? "#" + e + ".shape-divider { bottom: -" + (Number(g) - 1) + "px; } " : "#" + e + ".shape-divider { top: -" + (Number(g) -
        1) + "px; } ");
    g = c + "#" + e + ".shape-divider svg { " + f + m + " } #" + e + ".shape-divider .shape-divider-fill { fill: " + (k!=undefined ? k : a.closest('section').prev().css('background-color') + "; }"); 
    k = document.head || document.getElementsByTagName("head")[0];
    h = document.createElement("style");
    k.appendChild(h);
    h.type = "text/css";
    h.appendChild(document.createTextNode(g));
    a.attr("id", e);
    switch (d) {
        case "valley":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 355" preserveAspectRatio="none"><defs><style>.b{opacity:.5}.c{opacity:.3}</style></defs><path fill="none" d="M999.45 0H0v165.72l379.95 132.46L999.45 0z"></path><path class="b shape-divider-fill" d="M379.95 298.18l28.47 9.92L1000 118.75V0h-.55l-619.5 298.18zM492.04 337.25L1000 252.63V118.75L408.42 308.1l83.62 29.15z"></path><path class="b shape-divider-fill" d="M492.04 337.25L1000 252.63V118.75L408.42 308.1l83.62 29.15z"></path><path class="shape-divider-fill" d="M530.01 350.49l20.22 4.51H1000V252.63l-507.96 84.62 37.97 13.24z"></path><path class="b shape-divider-fill" d="M530.01 350.49l20.22 4.51H1000V252.63l-507.96 84.62 37.97 13.24z"></path><path class="b shape-divider-fill" d="M530.01 350.49l20.22 4.51H1000V252.63l-507.96 84.62 37.97 13.24z"></path><path class="shape-divider-fill" d="M542.94 355h7.29l-20.22-4.51 12.93 4.51z"></path><path class="b shape-divider-fill" d="M542.94 355h7.29l-20.22-4.51 12.93 4.51z"></path><path class="c shape-divider-fill" d="M542.94 355h7.29l-20.22-4.51 12.93 4.51z"></path><path class="b shape-divider-fill" d="M542.94 355h7.29l-20.22-4.51 12.93 4.51z"></path><path class="c shape-divider-fill" d="M379.95 298.18L0 165.72v66.59l353.18 78.75 26.77-12.88z"></path><path class="c shape-divider-fill" d="M353.18 311.06L0 232.31v71.86l288.42 38.06 64.76-31.17z"></path><path class="c shape-divider-fill" d="M353.18 311.06L0 232.31v71.86l288.42 38.06 64.76-31.17z"></path><path class="b shape-divider-fill" d="M380.28 317.11l28.14-9.01-28.47-9.92-26.77 12.88 27.1 6.05z"></path><path class="c shape-divider-fill" d="M380.28 317.11l28.14-9.01-28.47-9.92-26.77 12.88 27.1 6.05z"></path><path class="b shape-divider-fill" d="M479.79 339.29l12.25-2.04-83.62-29.15-28.14 9.01 99.51 22.18z"></path><path class="b shape-divider-fill" d="M479.79 339.29l12.25-2.04-83.62-29.15-28.14 9.01 99.51 22.18z"></path><path class="c shape-divider-fill" d="M479.79 339.29l12.25-2.04-83.62-29.15-28.14 9.01 99.51 22.18z"></path><path class="shape-divider-fill" d="M530.01 350.49l-37.97-13.24-12.25 2.04 50.22 11.2z"></path><path class="b shape-divider-fill" d="M530.01 350.49l-37.97-13.24-12.25 2.04 50.22 11.2z"></path><path class="b shape-divider-fill" d="M530.01 350.49l-37.97-13.24-12.25 2.04 50.22 11.2z"></path><path class="c shape-divider-fill" d="M530.01 350.49l-37.97-13.24-12.25 2.04 50.22 11.2zM288.42 342.23l9.46 1.25 82.4-26.37-27.1-6.05-64.76 31.17z"></path><path class="b shape-divider-fill" d="M288.42 342.23l9.46 1.25 82.4-26.37-27.1-6.05-64.76 31.17z"></path><path class="c shape-divider-fill" d="M288.42 342.23l9.46 1.25 82.4-26.37-27.1-6.05-64.76 31.17z"></path><path class="b shape-divider-fill" d="M380.28 317.11l-82.4 26.37 87.3 11.52h.34l94.27-15.71-99.51-22.18z"></path><path class="c shape-divider-fill" d="M380.28 317.11l-82.4 26.37 87.3 11.52h.34l94.27-15.71-99.51-22.18z"></path><path class="b shape-divider-fill" d="M380.28 317.11l-82.4 26.37 87.3 11.52h.34l94.27-15.71-99.51-22.18z"></path><path class="c shape-divider-fill" d="M380.28 317.11l-82.4 26.37 87.3 11.52h.34l94.27-15.71-99.51-22.18z"></path><path class="shape-divider-fill" d="M479.79 339.29L385.52 355h157.42l-12.93-4.51-50.22-11.2z"></path><path class="b shape-divider-fill" d="M479.79 339.29L385.52 355h157.42l-12.93-4.51-50.22-11.2z"></path><path class="c shape-divider-fill" d="M479.79 339.29L385.52 355h157.42l-12.93-4.51-50.22-11.2z"></path><path class="b shape-divider-fill" d="M479.79 339.29L385.52 355h157.42l-12.93-4.51-50.22-11.2z"></path><path class="c shape-divider-fill" d="M479.79 339.29L385.52 355h157.42l-12.93-4.51-50.22-11.2z"></path><path class="shape-divider-fill" d="M288.42 342.23L0 304.17V355h385.18l-87.3-11.52-9.46-1.25z"></path></svg>';
            break;
        case "valley-2":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none"><path class="shape-divider-fill" d="M194,99c186.7,0.7,305-78.3,306-97.2c1,18.9,119.3,97.9,306,97.2c114.3-0.3,194,0.3,194,0.3s0-91.7,0-100c0,0,0,0,0-0 L0,0v99.3C0,99.3,79.7,98.7,194,99z"></path></svg>';
            break;
        case "valley-3":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 140" preserveAspectRatio="none"><path class="shape-divider-fill" d="M1280 0L640 70 0 0v140l640-70 640 70V0z" opacity="0.5"></path><path class="shape-divider-fill" d="M1280 0H0l640 70 640-70z"></path></svg>';
            break;
        case "mountain":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none"><path class="shape-divider-fill" d="M500,98.9L0,6.1V0h1000v6.1L500,98.9z"></path></svg>';
            break;
        case "mountain-2":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 140" preserveAspectRatio="none"><path class="shape-divider-fill" d="M640 140L1280 0H0z" opacity="0.5"/><path class="shape-divider-fill" d="M640 98l640-98H0z"/></svg>';
            break;
        case "mountain-3":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 491.58" preserveAspectRatio="none"><g style="isolation:isolate"><path class="shape-divider-fill" d="M1000 479.4v-87.96L500 0 0 391.46v87.96l500-335.94 500 335.92z" opacity="0.12" mix-blend-mode="overlay"/><path class="shape-divider-fill" d="M1000 487.31v-7.91L500 143.48 0 479.42v7.91l500-297.96 500 297.94z" opacity="0.25" mix-blend-mode="overlay"/><path class="shape-divider-fill" d="M1000 487.31L500 189.37 0 487.33v4.25h1000v-4.27z"/></g></svg>';
            break;
        case "mountain-4":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none"><path class="shape-divider-fill" d="M738,99l262-93V0H0v5.6L738,99z"></path></svg>';
            break;
        case "mountain-5":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 140" preserveAspectRatio="none"><path class="shape-divider-fill" d="M978.81 122.25L0 0h1280l-262.1 116.26a73.29 73.29 0 0 1-39.09 5.99z" opacity="0.5"></path><path class="shape-divider-fill" d="M983.19 95.23L0 0h1280l-266 91.52a72.58 72.58 0 0 1-30.81 3.71z"></path></svg>';
            break;
        case "mountains":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none"><path class="shape-divider-fill" opacity="0.33" d="M473,67.3c-203.9,88.3-263.1-34-320.3,0C66,119.1,0,59.7,0,59.7V0h1000v59.7 c0,0-62.1,26.1-94.9,29.3c-32.8,3.3-62.8-12.3-75.8-22.1C806,49.6,745.3,8.7,694.9,4.7S492.4,59,473,67.3z"></path><path class="shape-divider-fill" opacity="0.66" d="M734,67.3c-45.5,0-77.2-23.2-129.1-39.1c-28.6-8.7-150.3-10.1-254,39.1 s-91.7-34.4-149.2,0C115.7,118.3,0,39.8,0,39.8V0h1000v36.5c0,0-28.2-18.5-92.1-18.5C810.2,18.1,775.7,67.3,734,67.3z"></path><path class="shape-divider-fill" d="M766.1,28.9c-200-57.5-266,65.5-395.1,19.5C242,1.8,242,5.4,184.8,20.6C128,35.8,132.3,44.9,89.9,52.5C28.6,63.7,0,0,0,0 h1000c0,0-9.9,40.9-83.6,48.1S829.6,47,766.1,28.9z"></path></svg>';
            break;
        case "mountains-2":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 247" preserveAspectRatio="none"><path class="shape-divider-fill" d="M0 200.92v.26l.75-.77-.75.51z"></path><path class="shape-divider-fill" d="M279.29 208.39c0-4.49 74.71-29.88 74.71-29.88l61.71 61.26L550 153.1l134.14 88.17L874.28 50 1000 178.51v-.33L874.28 0 684.14 191.27 550 103.1l-134.29 86.67L354 128.51s-74.71 25.39-74.71 29.88S144.23 52.08 144.23 52.08L.75 200.41l143.48-98.33s135.06 110.8 135.06 106.31z" opacity="0.25" isolation="isolate"></path><path class="shape-divider-fill" d="M1000 178.51L874.28 50 684.14 241.27 550 153.1l-134.29 86.67L354 178.51s-74.71 25.39-74.71 29.88-135.06-106.31-135.06-106.31L.75 200.41l-.75.77V247h1000z"></path><path class="shape-divider-fill" d="M1000 178.51L874.28 50 684.14 241.27 550 153.1l-134.29 86.67L354 178.51s-74.71 25.39-74.71 29.88-135.06-106.31-135.06-106.31L.75 200.41l-.75.77V247h1000z" opacity="0.25" isolation="isolate"></path></svg>';
            break;
        case "mountains-3":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none"><path class="shape-divider-fill" d="M761.9,44.1L643.1,27.2L333.8,98L0,3.8V0l1000,0v3.9"></path></svg>';
            break;
        case "mountains-4":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 140" preserveAspectRatio="none"><path class="shape-divider-fill" d="M0 90.72l140-28.28 315.52 24.14L796.48 65.8 1140 104.89l140-14.17V0H0v90.72z" opacity="0.5"></path><path class="shape-divider-fill" d="M0 0v47.44L170 0l626.48 94.89L1110 87.11l170-39.67V0H0z"></path></svg>';
            break;
        case "plataeu":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 140" preserveAspectRatio="none"><path class="shape-divider-fill" d="M1280 0l-131.81 111.68c-16.47 14-35.47 21-54.71 20.17L173 94a76.85 76.85 0 0 1-36.79-11.46L0 0z"></path></svg>';
            break;
        case "plataeu-2":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 140" preserveAspectRatio="none"><path class="shape-divider-fill" d="M1093.48 131.85L173 94a76.85 76.85 0 0 1-36.79-11.46L0 0h1280l-131.81 111.68c-16.47 13.96-35.47 20.96-54.71 20.17z" opacity="0.5"></path><path class="shape-divider-fill" d="M1094.44 119L172.7 68.72a74.54 74.54 0 0 1-25.19-5.95L0 0h1280l-133.85 102c-15.84 12.09-33.7 17.95-51.71 17z"></path></svg>';
            break;
        case "hills":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 140" preserveAspectRatio="none"><path class="shape-divider-fill" d="M156.258 127.903l86.363-18.654 78.684 13.079L411.441 99.4l94.454 10.303L582.82 93.8l82.664 18.728 76.961-11.39L816.109 71.4l97.602 9.849L997.383 50.4l66.285 14.694 70.793-24.494h79.863L1280 0H0v122.138l60.613 9.965z"/></svg>';
            break;
        case "hills-2":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 140" preserveAspectRatio="none"><path class="shape-divider-fill" d="M1214.323 66.051h-79.863l-70.793 18.224-66.285-10.933-83.672 22.953-97.601-7.328-73.664 22.125-76.961 8.475-82.664-13.934-76.926 11.832-94.453-7.666-90.137 17.059-78.684-9.731-86.363 13.879-95.644 3.125L0 126.717V0h1280l-.001 35.844z" opacity="0.5"></path><path class="shape-divider-fill" d="M0 0h1280v.006l-70.676 36.578-74.863 4.641-70.793 23.334-66.285-11.678-83.672 29.618-97.602-7.07-63.664 21.421-76.961 12.649-91.664-20.798-77.926 17.66-94.453-7.574-90.137 21.595-78.683-9.884-86.363 16.074-95.645 6.211L0 127.905z"></path></svg>';
            break;
        case "hills-3":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 140" preserveAspectRatio="none"><path class="shape-divider-fill" d="M156 35.51l95.46 34.84 120.04.24 71.5 33.35 90.09-3.91L640 137.65l102.39-37.17 85.55 10.65 88.11-7.19L992 65.28l73.21 5.31 66.79-22.1 77-.42L1280 0H0l64.8 38.69 91.2-3.18z"/></svg>';
            break;
        case "hills-4":
            c = '<svg viewBox="0 0 1280 140" preserveAspectRatio="none"><path class="shape-divider-fill" d="M156 35.41l95.46 34.73 120.04.25 71.5 33.24 90.09-3.89L640 137.25l102.39-37.06 85.55 10.61 88.11-7.17L992 65.08l73.21 5.31L1132 48.35l77-.42L1280 0H0l64.8 38.57 91.2-3.16z" opacity="0.5"/><path class="shape-divider-fill" d="M156 28.32l95.46 27.79 120.04.2L443 82.9l90.09-3.11L640 109.8l102.39-29.65 85.55 8.49 88.11-5.74L992 52.07l73.21 4.24L1132 38.68l77-.34L1280 0H0l64.8 30.86 91.2-2.54z"/></svg>';
            break;
        case "cloud":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.5 27.8" preserveAspectRatio="xMidYMax slice"><path class="shape-divider-fill" d="M0 0v6.7c1.9-.8 4.7-1.4 8.5-1 9.5 1.1 11.1 6 11.1 6s2.1-.7 4.3-.2c2.1.5 2.8 2.6 2.8 2.6s.2-.5 1.4-.7c1.2-.2 1.7.2 1.7.2s0-2.1 1.9-2.8c1.9-.7 3.6.7 3.6.7s.7-2.9 3.1-4.1 4.7 0 4.7 0 1.2-.5 2.4 0 1.7 1.4 1.7 1.4h1.4c.7 0 1.2.7 1.2.7s.8-1.8 4-2.2c3.5-.4 5.3 2.4 6.2 4.4.4-.4 1-.7 1.8-.9 2.8-.7 4 .7 4 .7s1.7-5 11.1-6c9.5-1.1 12.3 3.9 12.3 3.9s1.2-4.8 5.7-5.7c4.5-.9 6.8 1.8 6.8 1.8s.6-.6 1.5-.9c.9-.2 1.9-.2 1.9-.2s5.2-6.4 12.6-3.3c7.3 3.1 4.7 9 4.7 9s1.9-.9 4 0 2.8 2.4 2.8 2.4 1.9-1.2 4.5-1.2 4.3 1.2 4.3 1.2.2-1 1.4-1.7 2.1-.7 2.1-.7-.5-3.1 2.1-5.5 5.7-1.4 5.7-1.4 1.5-2.3 4.2-1.1c2.7 1.2 1.7 5.2 1.7 5.2s.3-.1 1.3.5c.5.4.8.8.9 1.1.5-1.4 2.4-5.8 8.4-4 7.1 2.1 3.5 8.9 3.5 8.9s.8-.4 2 0 1.1 1.1 1.1 1.1 1.1-1.1 2.3-1.1 2.1.5 2.1.5 1.9-3.6 6.2-1.2 1.9 6.4 1.9 6.4 2.6-2.4 7.4 0c3.4 1.7 3.9 4.9 3.9 4.9s3.3-6.9 10.4-7.9 11.5 2.6 11.5 2.6.8 0 1.2.2c.4.2.9.9.9.9s4.4-3.1 8.3.2c1.9 1.7 1.5 5 1.5 5s.3-1.1 1.6-1.4c1.3-.3 2.3.2 2.3.2s-.1-1.2.5-1.9 1.9-.9 1.9-.9-4.7-9.3 4.4-13.4c5.6-2.5 9.2.9 9.2.9s5-6.2 15.9-6.2 16.1 8.1 16.1 8.1.7-.2 1.6-.4V0H0z"></path></svg>';
            break;
        case "cloud-2":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 86" preserveAspectRatio="xMidYMid slice"><path class="shape-divider-fill" d="M1280 0H0v65.2c6.8 0 13.5.9 20.1 2.6 14-21.8 43.1-28 64.8-14 5.6 3.6 10.3 8.3 14 13.9 7.3-1.2 14.8-.6 21.8 1.6 2.1-37.3 34.1-65.8 71.4-63.7 24.3 1.4 46 15.7 56.8 37.6 19-17.6 48.6-16.5 66.3 2.4C323 54 327.4 65 327.7 76.5c.4.2.8.4 1.2.7 3.3 1.9 6.3 4.2 8.9 6.9 15.9-23.8 46.1-33.4 72.8-23.3 11.6-31.9 46.9-48.3 78.8-36.6 9.1 3.3 17.2 8.7 23.8 15.7 6.7-6.6 16.7-8.4 25.4-4.8 29.3-37.4 83.3-44 120.7-14.8 14 11 24.3 26.1 29.4 43.1 4.7.6 9.3 1.8 13.6 3.8 7.8-24.7 34.2-38.3 58.9-30.5 14.4 4.6 25.6 15.7 30.3 30 14.2 1.2 27.7 6.9 38.5 16.2 11.1-35.7 49-55.7 84.7-44.7 14.1 4.4 26.4 13.3 35 25.3 12-5.7 26.1-5.5 37.9.6 3.9-11.6 15.5-18.9 27.7-17.5.2-.3.3-.6.5-.9 23.3-41.4 75.8-56 117.2-32.6 14.1 7.9 25.6 19.7 33.3 33.8 28.8-23.8 71.5-19.8 95.3 9 2.6 3.1 4.9 6.5 6.9 10 3.8-.5 7.6-.8 11.4-.8L1280 0z"/></svg>';
            break;
        case "cloud-3":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 86" preserveAspectRatio="xMidYMid slice"><path class="shape-divider-fill" d="M833.9 27.5c-5.8 3.2-11 7.3-15.5 12.2-7.1-6.9-17.5-8.8-26.6-5-30.6-39.2-87.3-46.1-126.5-15.5-1.4 1.1-2.8 2.2-4.1 3.4C674.4 33.4 684 48 688.8 64.3c4.7.6 9.3 1.8 13.6 3.8 7.8-24.7 34.2-38.3 58.9-30.5 14.4 4.6 25.6 15.7 30.3 30 14.2 1.2 27.7 6.9 38.5 16.2C840.6 49.6 876 29.5 910.8 38c-20.4-20.3-51.8-24.6-76.9-10.5zM384 43.9c-9 5-16.7 11.9-22.7 20.3 15.4-7.8 33.3-8.7 49.4-2.6 3.7-10.1 9.9-19.1 18.1-26-15.4-2.3-31.2.6-44.8 8.3zm560.2 13.6c2 2.2 3.9 4.5 5.7 6.9 5.6-2.6 11.6-4 17.8-4.1-7.6-2.4-15.6-3.3-23.5-2.8zM178.7 7c29-4.2 57.3 10.8 70.3 37 8.9-8.3 20.7-12.8 32.9-12.5C256.4 1.8 214.7-8.1 178.7 7zm146.5 56.3c1.5 4.5 2.4 9.2 2.5 14 .4.2.8.4 1.2.7 3.3 1.9 6.3 4.2 8.9 6.9 5.8-8.7 13.7-15.7 22.9-20.5-11.1-5.2-23.9-5.6-35.5-1.1zM33.5 54.9c21.6-14.4 50.7-8.5 65 13 .1.2.2.3.3.5 7.3-1.2 14.8-.6 21.8 1.6.6-10.3 3.5-20.4 8.6-29.4.3-.6.7-1.2 1.1-1.8-32.1-17.2-71.9-10.6-96.8 16.1zm1228.9 2.7c2.3 2.9 4.4 5.9 6.2 9.1 3.8-.5 7.6-.8 11.4-.8V48.3c-6.4 1.8-12.4 5-17.6 9.3zM1127.3 11c1.9.9 3.7 1.8 5.6 2.8 14.2 7.9 25.8 19.7 33.5 34 13.9-11.4 31.7-16.9 49.6-15.3-20.5-27.7-57.8-36.8-88.7-21.5z" opacity="0.5"/><path class="shape-divider-fill" d="M0 0v66c6.8 0 13.5.9 20.1 2.6 3.5-5.4 8.1-10.1 13.4-13.6 24.9-26.8 64.7-33.4 96.8-16 10.5-17.4 28.2-29.1 48.3-32 36.1-15.1 77.7-5.2 103.2 24.5 19.7.4 37.1 13.1 43.4 31.8 11.5-4.5 24.4-4.2 35.6 1.1l.4-.2c15.4-21.4 41.5-32.4 67.6-28.6 25-21 62.1-18.8 84.4 5.1 6.7-6.6 16.7-8.4 25.4-4.8 29.2-37.4 83.3-44.1 120.7-14.8l1.8 1.5c37.3-32.9 94.3-29.3 127.2 8 1.2 1.3 2.3 2.7 3.4 4.1 9.1-3.8 19.5-1.9 26.6 5 24.3-26 65-27.3 91-3.1.5.5 1 .9 1.5 1.4 12.8 3.1 24.4 9.9 33.4 19.5 7.9-.5 15.9.4 23.5 2.8 7-.1 13.9 1.5 20.1 4.7 3.9-11.6 15.5-18.9 27.7-17.5.2-.3.3-.6.5-.9 22.1-39.2 70.7-54.7 111.4-35.6 30.8-15.3 68.2-6.2 88.6 21.5 18.3 1.7 35 10.8 46.5 25.1 5.2-4.3 11.1-7.4 17.6-9.3V0H0z"/></svg>';
            break;
        case "wave":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none"><path class="shape-divider-fill" d="M421.9,6.5c22.6-2.5,51.5,0.4,75.5,5.3c23.6,4.9,70.9,23.5,100.5,35.7c75.8,32.2,133.7,44.5,192.6,49.7c23.6,2.1,48.7,3.5,103.4-2.5c54.7-6,106.2-25.6,106.2-25.6V0H0v30.3c0,0,72,32.6,158.4,30.5c39.2-0.7,92.8-6.7,134-22.4c21.2-8.1,52.2-18.2,79.7-24.2C399.3,7.9,411.6,7.5,421.9,6.5z"></path></svg>';
            break;
        case "wave-2":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.5 27.8" preserveAspectRatio="none"><path class="shape-divider-fill" d="M283.5,9.7c0,0-7.3,4.3-14,4.6c-6.8,0.3-12.6,0-20.9-1.5c-11.3-2-33.1-10.1-44.7-5.7\ts-12.1,4.6-18,7.4c-6.6,3.2-20,9.6-36.6,9.3C131.6,23.5,99.5,7.2,86.3,8c-1.4,0.1-6.6,0.8-10.5,2c-3.8,1.2-9.4,3.8-17,4.7 c-3.2,0.4-8.3,1.1-14.2,0.9c-1.5-0.1-6.3-0.4-12-1.6c-5.7-1.2-11-3.1-15.8-3.7C6.5,9.2,0,10.8,0,10.8V0h283.5V9.7z M260.8,11.3 c-0.7-1-2-0.4-4.3-0.4c-2.3,0-6.1-1.2-5.8-1.1c0.3,0.1,3.1,1.5,6,1.9C259.7,12.2,261.4,12.3,260.8,11.3z M242.4,8.6 c0,0-2.4-0.2-5.6-0.9c-3.2-0.8-10.3-2.8-15.1-3.5c-8.2-1.1-15.8,0-15.1,0.1c0.8,0.1,9.6-0.6,17.6,1.1c3.3,0.7,9.3,2.2,12.4,2.7\tC239.9,8.7,242.4,8.6,242.4,8.6z M185.2,8.5c1.7-0.7-13.3,4.7-18.5,6.1c-2.1,0.6-6.2,1.6-10,2c-3.9,0.4-8.9,0.4-8.8,0.5\tc0,0.2,5.8,0.8,11.2,0c5.4-0.8,5.2-1.1,7.6-1.6C170.5,14.7,183.5,9.2,185.2,8.5z M199.1,6.9c0.2,0-0.8-0.4-4.8,1.1 c-4,1.5-6.7,3.5-6.9,3.7c-0.2,0.1,3.5-1.8,6.6-3C197,7.5,199,6.9,199.1,6.9z M283,6c-0.1,0.1-1.9,1.1-4.8,2.5s-6.9,2.8-6.7,2.7\tc0.2,0,3.5-0.6,7.4-2.5C282.8,6.8,283.1,5.9,283,6z M31.3,11.6c0.1-0.2-1.9-0.2-4.5-1.2s-5.4-1.6-7.8-2C15,7.6,7.3,8.5,7.7,8.6\tC8,8.7,15.9,8.3,20.2,9.3c2.2,0.5,2.4,0.5,5.7,1.6S31.2,11.9,31.3,11.6z M73,9.2c0.4-0.1,3.5-1.6,8.4-2.6c4.9-1.1,8.9-0.5,8.9-0.8 c0-0.3-1-0.9-6.2-0.3S72.6,9.3,73,9.2z M71.6,6.7C71.8,6.8,75,5.4,77.3,5c2.3-0.3,1.9-0.5,1.9-0.6c0-0.1-1.1-0.2-2.7,0.2\tC74.8,5.1,71.4,6.6,71.6,6.7z M93.6,4.4c0.1,0.2,3.5,0.8,5.6,1.8c2.1,1,1.8,0.6,1.9,0.5c0.1-0.1-0.8-0.8-2.4-1.3\tC97.1,4.8,93.5,4.2,93.6,4.4z M65.4,11.1c-0.1,0.3,0.3,0.5,1.9-0.2s2.6-1.3,2.2-1.2s-0.9,0.4-2.5,0.8C65.3,10.9,65.5,10.8,65.4,11.1 z M34.5,12.4c-0.2,0,2.1,0.8,3.3,0.9c1.2,0.1,2,0.1,2-0.2c0-0.3-0.1-0.5-1.6-0.4C36.6,12.8,34.7,12.4,34.5,12.4z M152.2,21.1 c-0.1,0.1-2.4-0.3-7.5-0.3c-5,0-13.6-2.4-17.2-3.5c-3.6-1.1,10,3.9,16.5,4.1C150.5,21.6,152.3,21,152.2,21.1z"></path><path class="shape-divider-fill" d="M269.6,18c-0.1-0.1-4.6,0.3-7.2,0c-7.3-0.7-17-3.2-16.6-2.9c0.4,0.3,13.7,3.1,17,3.3\tC267.7,18.8,269.7,18,269.6,18z"></path><path class="shape-divider-fill" d="M227.4,9.8c-0.2-0.1-4.5-1-9.5-1.2c-5-0.2-12.7,0.6-12.3,0.5c0.3-0.1,5.9-1.8,13.3-1.2\tS227.6,9.9,227.4,9.8z"></path><path class="shape-divider-fill" d="M204.5,13.4c-0.1-0.1,2-1,3.2-1.1c1.2-0.1,2,0,2,0.3c0,0.3-0.1,0.5-1.6,0.4\tC206.4,12.9,204.6,13.5,204.5,13.4z"></path><path class="shape-divider-fill" d="M201,10.6c0-0.1-4.4,1.2-6.3,2.2c-1.9,0.9-6.2,3.1-6.1,3.1c0.1,0.1,4.2-1.6,6.3-2.6\tS201,10.7,201,10.6z"></path><path class="shape-divider-fill" d="M154.5,26.7c-0.1-0.1-4.6,0.3-7.2,0c-7.3-0.7-17-3.2-16.6-2.9c0.4,0.3,13.7,3.1,17,3.3\tC152.6,27.5,154.6,26.8,154.5,26.7z"></path><path class="shape-divider-fill" d="M41.9,19.3c0,0,1.2-0.3,2.9-0.1c1.7,0.2,5.8,0.9,8.2,0.7c4.2-0.4,7.4-2.7,7-2.6\tc-0.4,0-4.3,2.2-8.6,1.9c-1.8-0.1-5.1-0.5-6.7-0.4S41.9,19.3,41.9,19.3z"></path><path class="shape-divider-fill" d="M75.5,12.6c0.2,0.1,2-0.8,4.3-1.1c2.3-0.2,2.1-0.3,2.1-0.5c0-0.1-1.8-0.4-3.4,0\tC76.9,11.5,75.3,12.5,75.5,12.6z"></path><path class="shape-divider-fill" d="M15.6,13.2c0-0.1,4.3,0,6.7,0.5c2.4,0.5,5,1.9,5,2c0,0.1-2.7-0.8-5.1-1.4\tC19.9,13.7,15.7,13.3,15.6,13.2z"></path></svg>';
            break;
        case "wave-3":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1047.1 3.7" preserveAspectRatio="xMidYMin slice"><path class="shape-divider-fill" d="M1047.1,0C557,0,8.9,0,0,0v1.6c0,0,0.6-1.5,2.7-0.3C3.9,2,6.1,4.1,8.3,3.5c0.9-0.2,1.5-1.9,1.5-1.9\ts0.6-1.5,2.7-0.3C13.8,2,16,4.1,18.2,3.5c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3C23.6,2,25.9,4.1,28,3.5c0.9-0.2,1.5-1.9,1.5-1.9\tc0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2\tc0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3C63,2,65.3,4.1,67.4,3.5\tC68.3,3.3,69,1.6,69,1.6s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3\tC82.7,2,85,4.1,87.1,3.5c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3C92.6,2,94.8,4.1,97,3.5c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3\tc1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9\tc0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2\tc0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3\tc1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9\tc0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2\tc0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3\tc1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9\tc0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2\tc0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3\tc1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9\ts0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2\tc0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3\tc1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9\ts0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2\tc0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3\tc1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9\ts0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2\tc0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3\tc1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9\ts0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2\tc0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3\tc1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9\ts0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2\tc0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3\tc1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9\ts0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2\tc0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3\tc1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9\tc0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2\tc0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3\tc1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9\tc0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2\tc0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3\tc1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9\tc0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2\tc0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3\tc1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9\ts0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2\tc0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3\tc1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9\ts0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2\tc0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3\tc1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9\ts0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2\tc0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3\tc1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9\ts0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2\tc0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3\tc1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9\ts0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2\tc0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3\tc1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9\ts0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2\tc0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3\tc1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9\tc0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9c0,0,0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2\tc0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3c1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.7-0.3\tc1.2,0.7,3.5,2.8,5.6,2.2c0.9-0.2,1.5-1.9,1.5-1.9s0.6-1.5,2.6-0.4V0z M2.5,1.2C2.5,1.2,2.5,1.2,2.5,1.2C2.5,1.2,2.5,1.2,2.5,1.2z M2.7,1.4c0.1,0,0.1,0.1,0.1,0.1C2.8,1.4,2.8,1.4,2.7,1.4z"></path></svg>';
            break;
        case "wave-4":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 140" preserveAspectRatio="none"><path class="shape-divider-fill" d="M0 51.76c36.21-2.25 77.57-3.58 126.42-3.58 320 0 320 57 640 57 271.15 0 312.58-40.91 513.58-53.4V0H0z" opacity="0.3"></path><path class="shape-divider-fill" d="M0 24.31c43.46-5.69 94.56-9.25 158.42-9.25 320 0 320 89.24 640 89.24 256.13 0 307.28-57.16 481.58-80V0H0z" opacity="0.5"></path><path class="shape-divider-fill" d="M0 0v3.4C28.2 1.6 59.4.59 94.42.59c320 0 320 84.3 640 84.3 285 0 316.17-66.85 545.58-81.49V0z"></path></svg>';
            break;
        case "wave-5":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 140" preserveAspectRatio="none"><path class="shape-divider-fill" d="M0 0v100c20 17.3 40 29.51 80 29.51 51.79 0 74.69-48.57 151.75-48.57 73.72 0 91 54.88 191.56 54.88C543.95 135.8 554 14 665.69 14c109.46 0 98.85 87 188.2 87 70.37 0 69.81-33.73 115.6-33.73 55.85 0 62 39.62 115.6 39.62 58.08 0 57.52-46.59 115-46.59 39.8 0 60 22.48 79.89 39.69V0z"></path></svg>';
            break;
        case "wave-6":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 140" preserveAspectRatio="none"><path class="shape-divider-fill" d="M504.854,80.066c7.812,0,14.893,0.318,21.41,0.879 c-25.925,22.475-56.093,40.852-102.946,40.852c-20.779,0-37.996-2.349-52.898-6.07C413.517,107.295,434.056,80.066,504.854,80.066z M775.938,51.947c19.145,18.596,39.097,35.051,77.956,35.051c46.907,0,62.299-14.986,80.912-24.98 c-21.357-15.783-46.804-28.348-85.489-28.348C816.829,33.671,794.233,41.411,775.938,51.947z" opacity="0.3"></path><path class="shape-divider-fill" d="M1200.112,46.292c39.804,0,59.986,22.479,79.888,39.69v16.805 c-19.903-10.835-40.084-21.777-79.888-21.777c-72.014,0-78.715,43.559-147.964,43.559c-56.84,0-81.247-35.876-117.342-62.552 c9.309-4.998,19.423-8.749,34.69-8.749c55.846,0,61.99,39.617,115.602,39.617C1143.177,92.887,1142.618,46.292,1200.112,46.292z M80.011,115.488c-40.006,0-60.008-12.206-80.011-29.506v16.806c20.003,10.891,40.005,21.782,80.011,21.782 c80.004,0,78.597-30.407,137.669-30.407c55.971,0,62.526,24.026,126.337,24.026c9.858,0,18.509-0.916,26.404-2.461 c-57.186-14.278-80.177-48.808-138.66-48.808C154.698,66.919,131.801,115.488,80.011,115.488z M526.265,80.945 c56.848,4.902,70.056,28.726,137.193,28.726c54.001,0,73.43-35.237,112.48-57.724C751.06,27.782,727.548,0,665.691,0 C597.381,0,567.086,45.555,526.265,80.945z" opacity="0.5"></path><path class="shape-divider-fill" d="M0,0v85.982c20.003,17.3,40.005,29.506,80.011,29.506c51.791,0,74.688-48.569,151.751-48.569 c58.482,0,81.473,34.531,138.66,48.808c43.096-8.432,63.634-35.662,134.433-35.662c7.812,0,14.893,0.318,21.41,0.879 C567.086,45.555,597.381,0,665.691,0c61.856,0,85.369,27.782,110.246,51.947c18.295-10.536,40.891-18.276,73.378-18.276 c38.685,0,64.132,12.564,85.489,28.348c9.309-4.998,19.423-8.749,34.69-8.749c55.846,0,61.99,39.617,115.602,39.617 c58.08,0,57.521-46.595,115.015-46.595c39.804,0,59.986,22.479,79.888,39.69V0H0z"></path></svg>';
            break;
        case "slant":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none"><path class="shape-divider-fill" d="M0,6V0h1000v100L0,6z"></path></svg>';
            break;
        case "slant-2":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2600 131.1" preserveAspectRatio="none"><path class="shape-divider-fill" d="M0 0L2600 0 2600 69.1 0 0z"></path><path class="shape-divider-fill" opacity="0.5" d="M0 0L2600 0 2600 69.1 0 69.1z"></path><path class="shape-divider-fill" opacity="0.25" d="M2600 0L0 0 0 130.1 2600 69.1z"></path></svg>';
            break;
        case "slant-3":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 140" preserveAspectRatio="none"><path class="shape-divider-fill" d="M1280 140V0H0l1280 140z" opacity="0.5"></path><path class="shape-divider-fill" d="M1280 98V0H0l1280 98z"></path></svg>';
            break;
        case "rounded":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none"><path class="shape-divider-fill" d="M1000,4.3V0H0v4.3C0.9,23.1,126.7,99.2,500,100S1000,22.7,1000,4.3z"></path></svg>';
            break;
        case "rounded-2":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none"><path class="shape-divider-fill" d="M0,0c0,0,0,6,0,6.7c0,18,240.2,93.6,615.2,92.6C989.8,98.5,1000,25,1000,6.7c0-0.7,0-6.7,0-6.7H0z"></path></svg>';
            break;
        case "rounded-3":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 140" preserveAspectRatio="none"><path class="shape-divider-fill" d="M0 0s573.08 140 1280 140V0z"></path></svg>';
            break;
        case "rounded-4":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 140" preserveAspectRatio="none"><path class="shape-divider-fill" d="M0 0v60s573.09 80 1280 80V0z" opacity="0.3"></path><path class="shape-divider-fill" d="M0 0v30s573.09 110 1280 110V0z" opacity="0.5"></path><path class="shape-divider-fill" d="M0 0s573.09 140 1280 140V0z"></path></svg>';
            break;
        case "rounded-5":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 140" preserveAspectRatio="none"><path class="shape-divider-fill" d="M0 0v.48C18.62 9.38 297.81 140 639.5 140 993.24 140 1280 0 1280 0z" opacity="0.3"></path><path class="shape-divider-fill" d="M0 .6c14 8.28 176.54 99.8 555.45 119.14C952.41 140 1280 0 1280 0H0z" opacity="0.5"></path><path class="shape-divider-fill" d="M726.29 101.2C1126.36 79.92 1281 0 1281 0H1c.05 0 325.25 122.48 725.29 101.2z"></path></svg>';
            break;
        case "triangle":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 700 10" preserveAspectRatio="none"><path class="shape-divider-fill" d="M350,10L340,0h20L350,10z"></path></svg>';
            break;
        case "drops":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.5 27.8" preserveAspectRatio="xMidYMax slice"><path class="shape-divider-fill" d="M0 0v1.4c.6.7 1.1 1.4 1.4 2 2 3.8 2.2 6.6 1.8 10.8-.3 3.3-2.4 9.4 0 12.3 1.7 2 3.7 1.4 4.6-.9 1.4-3.8-.7-8.2-.6-12 .1-3.7 3.2-5.5 6.9-4.9 4 .6 4.8 4 4.9 7.4.1 1.8-1.1 7 0 8.5.6.8 1.6 1.2 2.4.5 1.4-1.1.1-5.4.1-6.9.1-3.7.3-8.6 4.1-10.5 5-2.5 6.2 1.6 5.4 5.6-.4 1.7-1 9.2 2.9 6.3 1.5-1.1.7-3.5.5-4.9-.4-2.4-.4-4.3 1-6.5.9-1.4 2.4-3.1 4.2-3 2.4.1 2.7 2.2 4 3.7 1.5 1.8 1.8 2.2 3 .1 1.1-1.9 1.2-2.8 3.6-3.3 1.3-.3 4.8-1.4 5.9-.5 1.5 1.1.6 2.8.4 4.3-.2 1.1-.6 4 1.8 3.4 1.7-.4-.3-4.1.6-5.6 1.3-2.2 5.8-1.4 7 .5 1.3 2.1.5 5.8.1 8.1s-1.2 5-.6 7.4c1.3 5.1 4.4.9 4.3-2.4-.1-4.4-2-8.8-.5-13 .9-2.4 4.6-6.6 7.7-4.5 2.7 1.8.5 7.8.2 10.3-.2 1.7-.8 4.6.2 6.2.9 1.4 2 1.5 2.6-.3.5-1.5-.9-4.5-1-6.1-.2-1.7-.4-3.7.2-5.4 1.8-5.6 3.5 2.4 6.3.6 1.4-.9 4.3-9.4 6.1-3.1.6 2.2-1.3 7.8.7 8.9 4.2 2.3 1.5-7.1 2.2-8 3.1-4 4.7 3.8 6.1 4.1 3.1.7 2.8-7.9 8.1-4.5 1.7 1.1 2.9 3.3 3.2 5.2.4 2.2-1 4.5-.6 6.6 1 4.3 4.4 1.5 4.4-1.7 0-2.7-3-8.3 1.4-9.1 4.4-.9 7.3 3.5 7.8 6.9.3 2-1.5 10.9 1.3 11.3 4.1.6-3.2-15.7 4.8-15.8 4.7-.1 2.8 4.1 3.9 6.6 1 2.4 2.1 1 2.3-.8.3-1.9-.9-3.2 1.3-4.3 5.9-2.9 5.9 5.4 5.5 8.5-.3 2-1.7 8.4 2 8.1 6.9-.5-2.8-16.9 4.8-18.7 4.7-1.2 6.1 3.6 6.3 7.1.1 1.7-1.2 8.1.6 9.1 3.5 2 1.9-7 2-8.4.2-4 1.2-9.6 6.4-9.8 4.7-.2 3.2 4.6 2.7 7.5-.4 2.2 1.3 8.6 3.8 4.4 1.1-1.9-.3-4.1-.3-6 0-1.7.4-3.2 1.3-4.6 1-1.6 2.9-3.5 5.1-2.9 2.5.6 2.3 4.1 4.1 4.9 1.9.8 1.6-.9 2.3-2.1 1.2-2.1 2.1-2.1 4.4-2.4 1.4-.2 3.6-1.5 4.9-.5 2.3 1.7-.7 4.4.1 6.5.6 1.5 2.1 1.7 2.8.3.7-1.4-1.1-3.4-.3-4.8 1.4-2.5 6.2-1.2 7.2 1 2.3 4.8-3.3 12-.2 16.3 3 4.1 3.9-2.8 3.8-4.8-.4-4.3-2.1-8.9 0-13.1 1.3-2.5 5.9-5.7 7.9-2.4 2 3.2-1.3 9.8-.8 13.4.5 4.4 3.5 3.3 2.7-.8-.4-1.9-2.4-10 .6-11.1 3.7-1.4 2.8 7.2 6.5.4 2.2-4.1 4.9-3.1 5.2 1.2.1 1.5-.6 3.1-.4 4.6.2 1.9 1.8 3.7 3.3 1.3 1-1.6-2.6-10.4 2.9-7.3 2.6 1.5 1.6 6.5 4.8 2.7 1.3-1.5 1.7-3.6 4-3.7 2.2-.1 4 2.3 4.8 4.1 1.3 2.9-1.5 8.4.9 10.3 4.2 3.3 3-5.5 2.7-6.9-.6-3.9 1-7.2 5.5-5 4.1 2.1 4.3 7.7 4.1 11.6 0 .8-.6 9.5 2.5 5.2 1.2-1.7-.1-7.7.1-9.6.3-2.9 1.2-5.5 4.3-6.2 4.5-1 7.7 1.5 7.4 5.8-.2 3.5-1.8 7.7-.5 11.1 1 2.7 3.6 2.8 5 .2 1.6-3.1 0-8.3-.4-11.6-.4-4.2-.2-7 1.8-10.8 0 0-.1.1-.1.2-.2.4-.3.7-.4.8v.1c-.1.2-.1.2 0 0v-.1l.4-.8c0-.1.1-.1.1-.2.2-.4.5-.8.8-1.2V0H0zM282.7 3.4z"></path></svg>';
            break;
        case "cliff":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 279.24" preserveAspectRatio="none"><path class="shape-divider-fill" d="M1000 0S331.54-4.18 0 279.24h1000z" opacity="0.25"></path><path class="shape-divider-fill" d="M1000 279.24s-339.56-44.3-522.95-109.6S132.86 23.76 0 25.15v254.09z"></path></svg>';
            break;
        case "zigzag":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1800 5.8" preserveAspectRatio="none"><path class="shape-divider-fill" d="M5.4.4l5.4 5.3L16.5.4l5.4 5.3L27.5.4 33 5.7 38.6.4l5.5 5.4h.1L49.9.4l5.4 5.3L60.9.4l5.5 5.3L72 .4l5.5 5.3L83.1.4l5.4 5.3L94.1.4l5.5 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.2l5.6-5.4 5.4 5.3L161 .4l5.4 5.3L172 .4l5.5 5.3 5.6-5.3 5.4 5.3 5.7-5.3 5.4 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.4h.2l5.6-5.4 5.5 5.3L261 .4l5.4 5.3L272 .4l5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.1l5.7-5.4 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.7-5.3 5.4 5.4h.2l5.6-5.4 5.5 5.3L361 .4l5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.1l5.7-5.4 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.1l5.6-5.4 5.5 5.3L461 .4l5.5 5.3 5.6-5.3 5.4 5.3 5.7-5.3 5.4 5.3 5.6-5.3 5.5 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.1L550 .4l5.4 5.3L561 .4l5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.4 5.3 5.7-5.3 5.4 5.3 5.6-5.3 5.5 5.4h.2L650 .4l5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.4h.2L750 .4l5.5 5.3 5.6-5.3 5.4 5.3 5.7-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.1l5.7-5.4 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.4h.2L850 .4l5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.2l5.6-5.4 5.4 5.3 5.7-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.1l5.7-5.4 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.2l5.6-5.4 5.4 5.3 5.7-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.1l5.7-5.4 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.2l5.6-5.4 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.1l5.7-5.4 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.2l5.6-5.4 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.7-5.3 5.4 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.1l5.6-5.4 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.7-5.3 5.4 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.1l5.7-5.4 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.1l5.6-5.4 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.7-5.3 5.4 5.3 5.6-5.3 5.5 5.4V0H-.2v5.8z"></path></svg>';
            break;
        case "illusion":
            c = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.5 19.6" preserveAspectRatio="none"><path class="shape-divider-fill" opacity="0.33" d="M0 0L0 18.8 141.8 4.1 283.5 18.8 283.5 0z"></path><path class="shape-divider-fill" opacity="0.33" d="M0 0L0 12.6 141.8 4 283.5 12.6 283.5 0z"></path><path class="shape-divider-fill" opacity="0.33" d="M0 0L0 6.4 141.8 4 283.5 6.4 283.5 0z"></path><path class="shape-divider-fill" d="M0 0L0 1.2 141.8 4 283.5 1.2 283.5 0z"></path></svg>';
            break;
        default:
            c = ""
    }
    a.html(c);
    a.find("svg").addClass("op-ts");
    setTimeout(function() {
        a.find("svg").addClass("op-1")
    }, 500)
});
$(document).ready(function() {});
if ($(".datepicker").length || $(".timepicker").length || $(".datetimepicker").length) /Mobi/.test(navigator.userAgent) ? ($(".date input").attr("type", "date"), $(".time input").attr("type", "time")) : ($(".datepicker").datetimepicker({
    useCurrent: !1,
    format: "L",
    locale: langdouble,
    showTodayButton: !0,
    icons: {
        next: "fa fa-chevron-right",
        previous: "fa fa-chevron-left",
        today: "todayText"
    }
}), mdtimepicker(".timepicker", {
    format: "hh:mm",
    is24hour: !0,
    theme: "yellow",
    minTime: "6:00",
    maxTime: "22:00"
}), $(".datetimepicker").datetimepicker({
    format: "LLL",
    useCurrent: !1,
    locale: langdouble,
    icons: {
        time: "fa fa-clock",
        date: "fa fa-calendar",
        up: "fa fa-arrow-up",
        down: "fa fa-arrow-down"
    }
}));
$('[data-toggle="tooltip"]').tooltip();

if(window.matchMedia("(min-width: 992px)").matches){
	$('[data-toggle="tooltip"][data-trigger="manual"]').tooltip('show');
}
$('[data-toggle="popover"]').popover();
$('[data-toggle="popover"]').on("shown.bs.popover", function() {
    $(".grid").not($(this).parent().parent()).not(":last").css({
        pointerEvents: "none",
        opacity: .2,
        filter: "blur(4px)"
    })
});
$('[data-toggle="popover"]').on("hidden.bs.popover", function() {
    $(".grid").removeAttr("style")
});

function random_rgba() {
    var a = Math.round,
        d = Math.random;
    return "rgba(" + a(255 * d()) + "," + a(255 * d()) + "," + a(255 * d()) + ",0.6)"
}
$(window).on("load", function() {
    var a = $(".ph-item"),
        d = 1500;
    shuffle(a).each(function(f) {
        var g = this;
        setTimeout(function() {
            $(g).addClass("blink")
        }, d);
        d += 1400;
        setTimeout(function() {
            $(g).removeClass("blink")
        }, d)
    })
});
setTimeout(function() {
    $(".off").removeClass("off")
}, 100);
$(".fadebg2").length && !$(".jquery-bg-slideshow-wrap-bg-element").length && $(".fadebg2").bgSlideShow({
    images: imgs,
    transitionDelay: 6E3,
    transitionSpeed: 1E3,
    transitionEffect: "fade-in",
    randomize: !0,
    initialBackground: "random",
    debug: !1,
    slideControls: {
        enabled: !1,
        classes: ""
    }
});
$(".read-more-blocks").on("click", function(a) {
    a.preventDefault();
    a = $(this).parent();
    $(this).parent().find("> div").not(":first").is(":visible") ? (a.find("div").first().after(this), $(this).html($(this).attr("data-collapse")), $(this).parent().find("> div").not(":first").hide(), $("html,body").animate({
        scrollTop: $(this).closest(".container").parent().offset().top - $("header").height() - $(".mainnav").height() - 20
    })) : ($(this).appendTo(a), $(this).parent().find("> div").show(), $(this).html($(this).attr("data-open")))
});
$(".team-show-more").on("click", function(a) {
    a.preventDefault();
    a = $(this).parent();
    $(this).parent().find("> div").not(":first").is(":visible") ? (a.find("div").first().after(this), $(this).parent().find("> div").not(":first").hide(), $(this).html($(this).attr("data-collapse")), $("html,body").animate({
        scrollTop: $(this).closest(".container").parent().offset().top - $("header").height() - $(".mainnav").height() - 20
    })) : ($(this).appendTo(a), $(this).parent().find("> div").show(), $(this).html($(this).attr("data-open")))
});
$("html body.shrink").on("mouseenter", "li.nav-item.ml-1", function(a) {
    $(this).find("source").attr("srcset", $(this).find("img").attr("data-hover"))
}).on("mouseleave", "li.nav-item.ml-1", function(a) {
    $(this).find("source").attr("srcset", $(this).find("img").attr("data-origd"))
});
$(".mainnav > div:not(.scroll-nav) .nav-item.has-subnav,nav .nav-item.has-subnav").each(function() {
    var a = this;
    $(">a", this).on("click", function(d) {
        $('#sidecontact-close').trigger('click');
		!$(a).hasClass("clicked") && window.matchMedia("(min-width: 768px)").matches && (d.preventDefault(), 0 < $(".fullheight").length && $(window).scrollTop() < $(window).height() , $("main,.scroll-nav,.parallax-mirror,.logo + div").css({
            opacity: 1
        }), $(".clicked").removeClass("clicked"), $("body").addClass("subnav-open"), $(a).addClass("clicked"), $("body").click(function(f) {
            $('body').hasClass('subnav-open') && 0 == $(f.target).closest(".nav-item").length && 0 == $(f.target).closest(".popover").length && ($(".clicked").removeClass("clicked"), $("main,.scroll-nav,.parallax-mirror,.logo + div").css("opacity",1), $("body").removeClass("subnav-open"))
        }));
    })
});
$(".mapcollapse").on("shown.bs.collapse", function() {
    $(".eventMap", this).hasClass("leaflet-container") || $(".eventMap:visible", this).each(function(a, d) {
        a = $(this).attr("id");
        d = $(this).attr("data-lat");
        var f = $(this).attr("data-lon"),
            g = $(this).attr("data-zoom"),
            k = $(this).attr("data-marker"),
            h = L.map(a, {
                scrollWheelZoom: !1
            }).setView([d, f], g);
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(h);
        L.marker([d, f]).addTo(h).bindPopup(k).openPopup();
        h.on("focus", function() {
            h.scrollWheelZoom.enable()
        })
    })
});
var orderObj = {
    comment: "",
    accountid: 0,
    newclient: {
        title: 0,
        firstname: "",
        lastname: "",
        company: "",
        ordertype: 0,
        street: "",
        streetnr: "",
        zip: 0,
        place: "",
        phone: "",
        email: "",
        pw: "",
        agb: 0
    },
    offer: {
        format: "",
        voucher: "",
        offerid: 0,
        acadid: "",
        offertitle: "",
        offertext: "",
        price: 0,
        total: 0,
        amount: 0,
        isparticipant: 1,
        eventID: 0,
        bonus: 0
    }
};
$("#cartmodal").on("show.bs.modal", function(a) {
    $(a.relatedTarget).attr("data-id");
    var d = $(a.relatedTarget).attr("data-acadid"),
        f = $(a.relatedTarget).attr("data-bundle"),
        g = $(a.relatedTarget).attr("data-eventid"),
        k = $(a.relatedTarget).attr("data-type").toUpperCase(),
        h = $(a.relatedTarget).attr("data-from"),
        b = $(a.relatedTarget).attr("data-to"),
        e = $(a.relatedTarget).attr("data-location"),
        c = $(a.relatedTarget).attr("data-price"),
        m = $(a.relatedTarget).closest(".konfrow").find("h3").html(),
        q = '<span class="d-block">' +
        (void 0 != e && "" != e ? e + ", " : "") + (void 0 != h && "" != h ? " " + h + " bis " + b : "") + (void 0 != c && "" != c && 0 != c ? "<br/>CHF " + c + " pro Teilnehmenden" : "") + "</span>";
    h = $(a.relatedTarget).attr("data-remote");
    $(this).load(h + (-1 < h.indexOf("?") ? "&" : "?") + "_cache=" + (new Date).getTime() + " .modal-dialog", function() {
        $("#cartmodal").attr("data-price", c);
        $("#cartmodal").attr("data-academyid", d);
        $("#cartmodal").attr("data-bundleid", f);
        $("#cartmodal").attr("data-eventid", g);
        $("#cartmodal .rt").hide();
        $("#cartmodal ." + $(a.relatedTarget).attr("data-type")).show();
        $("#cartmodal .ktitel").prev().text("PEAQ " + k);
        $("#cartmodal .ktitel").html(m);
        $("#cartmodal .ktitel2").html(q);
        $('#cartmodal [data-toggle="tooltip"]').tooltip();
        "INHOUSE" == k && ($('#cartmodal [name="ordertype"]').val(2), $("#cartmodal .choose-order-type").hide());
        $("#form-1").validator();
        $("#order-form").validator();
        signin()
    })
});
$("#checkoutmodal").on("show.bs.modal", function(a) {
    $("#modal").modal("hide");
    a = $(a.relatedTarget).attr("data-remote");
    $(this).load(a + (-1 < a.indexOf("?") ? "&" : "?") + "_cache=" + (new Date).getTime() + " .modal-dialog", function() {
        $("#order-form").validator();
        $(".signin").validator();
        signin()
    });
    $(".clicked").removeClass("clicked");
    $("main,.scroll-nav").removeAttr("style")
});
$(document).on("click", "#c li input", function() {
    0 < $("#c li input:checked").length && !$(".close-choose i").hasClass("fa-check") ? $(".close-choose i").toggleClass("fa-check fa-times") : 0 == $("#c li input:checked").length && $(".close-choose i").toggleClass("fa-check fa-times")
});
$(document).on("click", ".close-choose", function() {
    0 < $("#c li input:checked").length ? $(".choose span").text("(" + $("#c li input:checked").length + ")") : $(".choose span").text("")
});

function showToast(a, d, f) {
    var g = $("#toast-blueprint").html();
    $("#toasts").append(g);
    $(".toast:last-child .toast-titel", "#toasts").html(a);
    $(".toast:last-child .toast-body", "#toasts").html(f);
    $(".toast:last-child .toast-time", "#toasts").html(d);
    $("#toasts").show();
    $("#toasts .toast:last-child").toast("show")
}
$(document).on("click", "#step1 .row-divided .btn", function(a) {
    a.preventDefault();
    a.stopPropagation();
    orderObj.offer.format = "";
    orderObj.offer.voucher = "";
    orderObj.offer.offerid = 0;
    orderObj.offer.acadid = "";
    orderObj.offer.offertitle = "";
    orderObj.offer.offertext = "";
    orderObj.offer.price = 0;
    orderObj.offer.total = 0;
    orderObj.offer.amount = 0;
    orderObj.offer.isparticipant = 1;
    orderObj.offer.eventID = 0;
    a = $(this).hasClass("btncart");
    if ($("#form-1").length && $("#form-1").data("bs.validator").validate().hasErrors()) $("#form-1").validator("validate");
    else if (orderObj.offer.offerid = $('#form-1 [name="id"]').val(), orderObj.offer.format = $('#form-1 [name="type"]').val(), orderObj.offer.ordertype = $('#form-1 [name="ordertype"]:checked').val(), $('.cart-offer[data-offerid="' + orderObj.offer.offerid + '"][data-offerformat="' + orderObj.offer.format + '"]').length && -1 < ["coaching,inhouse"].indexOf(orderObj.offer.format)) $("#cartmodal").modal("hide"), showToast("Warenkorb", "soeben", "Angebot ist bereits im Warenkorb");
    else {
        void 0 != $('#form-1 [name="anzahl"]').val() &&
            (orderObj.offer.amount = parseInt($('#form-1 [name="anzahl"]').val()));
        1 == $('#form-1 [name="isparticipant"]:checked').length && (orderObj.offer.isparticipant = $('#form-1 [name="isparticipant"]').val());
        void 0 != $('#form-1 [name="ausgangslage"]').val() && (orderObj.offer.offertext = "<strong>Ausgangslage:</strong><br/>" + $('#form-1 [name="ausgangslage"]').val());
        void 0 != $('#form-1 [name="service"]:checked').val() && (orderObj.offer.offertext += "<br/><strong>Organisation Seminarhotel:</strong><br/>" + $('#form-1 [name="service"]:checked').val());
        void 0 != $('#form-1 [name="format"]:checked').val() && (orderObj.offer.offertext += "<br/><strong>Gew\u00fcnschtes Format:</strong><br/> " + $('#form-1 [name="format"]:checked').val());
        void 0 != $('#form-1 [name="transfer"]:checked').val() && (orderObj.offer.offertext += "<br/><strong>Vertiefung mit Mircolearning:</strong><br/>" + $('#form-1 [name="transfer"]:checked').val());
        0 != orderObj.offer.amount && (orderObj.offer.offertext += '<strong>Anzahl Teilnehmer:innen:</strong> <span class="decrease mx-1 cursor-pointer"><i class="fas fa-minus-circle text-default"></i></span><span class="amount">' +
            orderObj.offer.amount + '</span><span class="increase mx-1 cursor-pointer"><i class="fas fa-plus-circle text-default"></i></span>', orderObj.offer.offertext += "<br/><strong>Ich bin Teilnehmer:in:</strong> " + (1 == orderObj.offer.isparticipant ? "Ja" : "Nein"));
        void 0 != $('#form-1 [name="vouchercode"]').val() && $('#form-1 [name="vouchercode"]').val().length && (orderObj.offer.voucher = $('#form-1 [name="vouchercode"]').val(), orderObj.offer.offertext += "<br/><strong><small>Gutscheincode:</strong><br/>" + orderObj.offer.voucher);
        if (void 0 != $('#form-1 [name="weitere_themen"]:checked').val()) {
            var d = [];
            $('#form-1 [name="weitere_themen"]:checked').each(function() {
                d.push($(this).val())
            });
            orderObj.offer.offertext += "<br/><strong>Zus\u00e4tzliche Trainingsthemen:</strong><br/>" + d.toString().replaceAll(",", "<br/>")
        }
        orderObj.offer.offertitle = $("#cartmodal .ktitel").html() + " - " + $("#cartmodal .ktitel2").html().replace(/(<([^>]+)>)/gi, "<br/>");
        orderObj.offer.price = void 0 != $("#cartmodal").attr("data-price") && 0 != $("#cartmodal").attr("data-price") ?
            parseFloat($("#cartmodal").attr("data-price")).toFixed(2) : 0;
        orderObj.offer.acadid = void 0 != $("#cartmodal").attr("data-academyid") && "" != $("#cartmodal").attr("data-academyid") ? $("#cartmodal").attr("data-academyid") : 0;
        orderObj.offer.bundleid = void 0 != $("#cartmodal").attr("data-bundleid") && "" != $("#cartmodal").attr("data-bundleid") ? $("#cartmodal").attr("data-bundleid") : 0;
        orderObj.offer.eventID = void 0 != $("#cartmodal").attr("data-eventid") && "" != $("#cartmodal").attr("data-eventid") ? $("#cartmodal").attr("data-eventid") :
            0;
        orderObj.offer.total = parseFloat(parseInt(orderObj.offer.amount) * parseFloat(orderObj.offer.price)).toFixed(2);
        0 < orderObj.offer.total && ($("#cartmodal .of1").hide(), $("#cartmodal .of2").show());
        a ? $.post("/assets/inc/customincludes/cart/addtocart.cfm?_cache=" + (new Date).getTime(), {
            order: JSON.stringify(orderObj.offer)
        }, function(f) {
            "1" == f.trim() ? ($("#cartmodal").modal("hide"), showToast("Warenkorb", "soeben", "Angebot ist bereits im Warenkorb")) : "0" != f.trim() ? ($(".shopcart").html(f), $("#cartmodal").modal("hide"),
                showToast("Warenkorb", "soeben", "Erfolgreich in den Warenkorb gelegt"), gtag("event", "conversion", {
                    send_to: "AW-10835980203/OfR8CKXWi5QDEKvf_64o",
                    value: 1,
                    currency: "CHF"
                })) : showToast("Warenkorb", "soeben", "Angebot konnte nicht in den Warenkorb gelegt werden.<br/>Versuche Sie es nocheinmal oder kontaktiere uns unter support@peaq-solutions.com.")
        }) : ($(".modal-body #step4 .col1").find("h3").html($("#cartmodal .ktitel").html()), $(".modal-body #step4 .col1").find("h3 + span").html($("#cartmodal .ktitel2").html()),
            void 0 != orderObj.offer.amount && 0 != orderObj.offer.amount ? $(".modal-body #step4 .col1").find("h3 + span + span").html(orderObj.offer.amount + " Anzahl Teilnehmer:innen \u00e0 CHF " + parseFloat($("#cartmodal").attr("data-price")).toFixed(2) + "<br/><strong>Total CHF " + parseFloat(parseInt(orderObj.offer.amount) * parseInt($("#cartmodal").attr("data-price"))).toFixed(2) + "</strong>") : $(".modal-body #step4 .col1").find("h3 + span + span").html(orderObj.offer.offertext), $(".modal-body > div").hide(0), $(".modal-body #step2").show(0,
                function() {
                    setTimeout(function() {
                        $(".modal-body").scrollTop(0)
                    }, 10)
                }))
    }
});
$("#order-form").validator().on("submit", function(a) {
    orderObj.newclient.title = $('#order-form [name="anrede"]').val();
    orderObj.newclient.firstname = $('#order-form [name="vorname"]').val();
    orderObj.newclient.lastname = $('#order-form [name="name"]').val();
    orderObj.newclient.company = $('#order-form [name="firma"]').val();
    orderObj.newclient.phone = $('#order-form [name="tel"]').val();
    orderObj.newclient.email = $('#order-form [name="email"]').val();
    orderObj.comment = $('#order-form [name="kommentar"]').val();
    void 0 !=
        $('#order-form [name="strasse"]').val() && (orderObj.newclient.street = $('#order-form [name="strasse"]').val());
    void 0 != $('#order-form [name="nr"]').val() && (orderObj.newclient.streetnr = $('#order-form [name="nr"]').val());
    void 0 != $('#order-form [name="plz"]').val() && (orderObj.newclient.zip = $('#order-form [name="plz"]').val());
    void 0 != $('#order-form [name="ort"]').val() && (orderObj.newclient.place = $('#order-form [name="ort"]').val());
    void 0 != $('#order-form [name="pw"]').val() && (orderObj.newclient.pw = $('#order-form [name="pw"]').val());
    $(".modal-body #step4 .col2").find("h3").html(orderObj.newclient.title + " " + orderObj.newclient.firstname + " " + orderObj.newclient.lastname + ("" != orderObj.newclient.company ? " (" + orderObj.newclient.company + ")" : ""));
    "" != orderObj.newclient.place && $(".modal-body #step4 .col2").find("h3 + span").html(orderObj.newclient.street + " " + orderObj.newclient.streetnr + "<br/>" + orderObj.newclient.zip + " " + orderObj.newclient.place);
    $(".modal-body #step4 .col2").find("h3 + span + span").html('<i class="fas fa-phone"></i> ' +
        orderObj.newclient.phone + '<br/><i class="fas fa-envelope"></i> ' + orderObj.newclient.email + ("" != orderObj.comment ? "<br/><br/><strong>Ihre Mitteilung</strong><br/>" + orderObj.comment : ""));
    $(".modal-body > div").hide(0);
    $(".modal-body #step4").show(0, function() {
        setTimeout(function() {
            $(".modal-body").scrollTop(0)
        }, 10)
    })
});
$(document).on("click", "#step4 .btn", function(a) {
    $.post("/assets/inc/customincludes/cart/order.cfm?_cache=" + (new Date).getTime(), {
        x: JSON.stringify(orderObj)
    }, function(d) {
        $(".modal-body > div").hide();
        $(".modal-body #step5").show();
        setTimeout(function() {
            $(".modal-body").scrollTop(0)
        }, 10)
    })
});
$(document).on("click", "[data-jump]", function(a) {
    a.preventDefault();
    a = $(this).attr("data-jump");
    $(".modal-body > div").hide(0);
    $(".modal-body " + a).show(0, function() {
        setTimeout(function() {
            $(".modal-body").scrollTop(0)
        }, 10)
    })
});
$(document).on("click", '[name="business"]', function(a) {
    $(".gotocheckout").attr("href", $(".gotocheckout").attr("href").split("?")[0] + "?b=" + $(this).val())
});

function signin() {
    $(".signin").validator().on("submit", function(a) {
        if (!a.isDefaultPrevented()) {
            a.preventDefault();
            var d = grecaptcha.render("inline-badge2", {
                sitekey: "6LfT5dcbAAAAACWIu4UBJ6i7JfvjMv8SrSVdhcdF",
                badge: "inline",
                size: "invisible"
            });
            grecaptcha.ready(function() {
                grecaptcha.execute(d, {
                    action: "homepage"
                }).then(function(f) {
                    f = new FormData($(".signin")[0]);
                    $.ajax({
                        url: "/assets/inc/customincludes/cart/signin.cfm?lang=" + lang,
                        data: f,
                        cache: !1,
                        contentType: !1,
                        processData: !1,
                        method: "POST",
                        type: "POST",
                        success: function(g) {
                            g.state ?
                                (orderObj.accountid = g.accountid, $("#cartmodal #step2 .row-divided").html(g.msg), $("#checkoutmodal #step0 .row-divided").html(g.msg)) : (alert(g.msg), g.pending && ($(".login").hide(), $(".verif input").prop("disabled", !1).prop("required", !0), $(".signin").validator("update"), $(".verif").show()))
                        }
                    })
                })
            })
        }
    })
}
signin();
$(document).on("click", ".cartclear", function(a) {
    a.preventDefault();
    $.get("/assets/inc/customincludes/cart/clearcart.cfm", {}, function(d) {
        $(".shopcart").html(d);
        $(".shopcartcontainer").html(d);
        $("#cartmodal .modal-body,#modal .modal-body").html(d);
        $(".cartpage span").remove();
        $("#cart-fab").hide();
        $("main,.scroll-nav").css({
            opacity: 1,
            filter: "none"
        });
        orderObj.offer = {
            format: "",
            voucher: "",
            offerid: 0,
            acadid: "",
            offertitle: "",
            offertext: "",
            price: 0,
            total: 0,
            amount: 0,
            isparticipant: 0
        }
    })
});
$(document).on("click", ".cartremoveitem", function(a) {
    a.preventDefault();
    showLoading(!0);
    $.get("/assets/inc/customincludes/cart/cartremoveitem.cfm", {
        item: $(this).attr("data-item")
    }, function(d) {
        $(".shopcart").html(d);
        $(".shopcartcontainer").html(d);
        $("#cartmodal .modal-body,#modal .modal-body").html(d);
        showLoading(!1);
        showToast("Warenkorb", "soeben", "Erfolgreich aus Warenkorb entfernt")
    })
});
$(document).on("click", ".increase", function(a) {
    a.preventDefault();
    showLoading(!0);
    $.get("/assets/inc/customincludes/cart/cartparticipant.cfm?_cache=" + (new Date).getTime(), {
        dir: "up",
        item: $(this).closest(".row").find("[data-item]").attr("data-item")
    }, function(d) {
        $(".shopcart").html(d);
        $(".shopcartcontainer").html(d);
        $("#cartmodal .modal-body,#modal .modal-body").html(d);
        showLoading(!1);
        showToast("Warenkorb", "soeben", "Teilnehmerzahl erfolgreich erh\u00f6ht")
    })
});
$(document).on("click", ".decrease", function(a) {
    a.preventDefault();
    showLoading(!0);
    $.get("/assets/inc/customincludes/cart/cartparticipant.cfm?_cache=" + (new Date).getTime(), {
        dir: "down",
        item: $(this).closest(".row").find("[data-item]").attr("data-item")
    }, function(d) {
        $(".shopcart").html(d);
        $(".shopcartcontainer").html(d);
        $("#cartmodal .modal-body,#modal .modal-body").html(d);
        showLoading(!1);
        showToast("Warenkorb", "soeben", "Teilnehmerzahl erfolgreich reduziert")
    })
});
if ((null != window.sessionStorage.getItem("mn") && (parseInt(JSON.parse(window.sessionStorage.getItem("mn")).version) != vrs || JSON.parse(window.sessionStorage.getItem("mn")).region != inter)) || null == window.sessionStorage.getItem("mn")) $.get("/assets/inc/mobilenav3.cfm",{inter: inter,id: pid, language: lang}, function(a) {
    $("body").append(a);
    window.sessionStorage.setItem("mn", JSON.stringify({
        version: vrs,
		region: inter,
        html: a
    }));
    a = new MmenuLight(document.querySelector("#mobile-menu"), "(max-width: 1390px)");
    a.navigation({
        title: "Peakly",
        selected: "selected"
    });
    var d = a.offcanvas({
        position: "right"
    });
    $(".mobnav").animate({opacity:1})
    $(".mobnav").on("click", function(f) {
        f.preventDefault();
        d.open()
		$('#sidecontact-close').trigger('click')
    })
	/*if(cp == 'YES'){
		$('#mobile-menu ul').append('<li><a class="ccrevoke" data-cc="show-preferencesModal" href="'+cplanding +'" target="_blank" rel="noopener">Cookie Einstellungen</a></li>')	
		
	}*/
});
else {
    $("body").append(JSON.parse(window.sessionStorage.getItem("mn")).html);
    $("#mobile-menu a").removeClass("active");
    $('#mobile-menu a[href="' + window.location.pathname + '"]').addClass("active");
    $('#mobile-menu a[href="' + window.location.pathname + '"]').parent("li").parent("ul").prev("a").addClass("active");
    $('#mobile-menu a[href="' + window.location.pathname + '"]').parent("li").parent("ul").parent("li").parent("ul").prev("a").addClass("active");
    var menu = new MmenuLight(document.querySelector("#mobile-menu"),"(max-width: 1320px)");
    var navigatorx = menu.navigation({
            title: "Peakly",
            selected: "selected"
        }),
        drawer = menu.offcanvas({
            position: "right"
        });
    $(".mobnav").animate({opacity:1})
	$(".mobnav").on("click", function(a) {
        a.preventDefault();
        drawer.open()
		$('#sidecontact-close').trigger('click')
		
    })
	if(cp == 'YES'){
		$('#mobile-menu > ul').append('<li><a class="ccrevoke" data-cc="show-preferencesModal" href="'+cplanding+'" target="_blank" rel="noopener">Cookie Einstellungen</a></li>')	
		
	}
}
$(".grouploop").each(function(){
	$('#'+$(this).prop('id')).grouploop({
		velocity: 1,
		forward: !1,
		childNode: ".item",
		childWrapper: ".item-wrap",
		pauseOnHover: !0,
		stickFirstItem: !1 
	});
}) 
 
$('#sidecontact').on('click',function(e){
	$('#modal').modal('hide')
	$('#sidecontact-close').toggleClass('closed')
	$('body').toggleClass('slidecontact-open')
	
	if($('body').hasClass('slidecontact-open')){
		
		$('main,.logo + div,.parallax-mirror,footer').css({ 
			opacity: 0.2
		})
		$('.tooltip').hide()
	}
	else{
		$('main,.logo + div,.parallax-mirror,footer').css({ 
			opacity: 1
		})
		$('.tooltip').show()
	}
	
})

$('#sidecontact-close').on('click',function(e){
	e.preventDefault();
	
	$('body').removeClass('slidecontact-open')
	$('body').removeClass('subnav-open')
	$('main,.logo + div,.parallax-mirror,footer').css({
		opacity: 1
	})
	$('.logo + div,.parallax-mirror,footer').css({
		minHeight: 0
	})
	$('.tooltip').show()
})

$('#sidecontactslide').on('click', function(e) {
  
  if (e.target !== this)
    return;
  
  $('#sidecontact-close').trigger('click')
});
$('.tooltip').css({opacity:0})
$('.cplayer').each(function(i,e){
	var skinpath = 	$(this).attr('data-skin-path');
	var playerID = $(this).attr('id');
	var playlist = JSON.parse($(this).attr('data-playlist'));
	var image = $(this).attr('data-cover');
	
	new Calamansi($('#'+playerID)[0], {
		skin: skinpath,
		playlists: playlist,
		defaultAlbumCover: image
	});
}) 
$(".formgen input").on("focus touchstart", function(a) {
    if (void 0 !== a.originalEvent) {
        var d = this;
        0 == $(this).closest(".formgen").find('[name="peaqtoken"]').length && $.get("/assets/inc/ptoken.cfm", {}, function(f) {
            $(d).closest(".formgen").append('<input type="hidden" readonly name="peaqtoken" value="' + f.trim() + '" />')
        })
    }
}); 
"undefined" !== typeof dev && dev && ($(".toggle-inactive").on("click", function(a) {
   $("[data-inactive]").each(function(){
		var state = $(".toggle-inactive").prop("checked") ? 'position:relative;left:0;top:0;' : 'position:absolute;left:-99999px;top:0;width:100%;';
		$(this).attr('style',state);
		
	 })
	window.dispatchEvent(new Event("resize"))
    
	window.sessionStorage.setItem("state", $(".toggle-inactive").prop("checked"));
	
    "false" == window.sessionStorage.getItem("state") ? ($("[data-inactive]").toggleClass('d-block d-none'), $(".toggle-inactive").prop("checked", !1)) : ($("[data-inactive]").toggleClass('d-none d-block'), $(".toggle-inactive").prop("checked", !0));
    $("section").removeClass("last");
    $(".floating-sidebar").length ? window.matchMedia("(max-width: 767px)").matches ? $(".floating-sidebar").addClass("last") :
        $("section").not(":hidden").last().addClass("last") : $("section").not(":hidden").last().addClass("last")
}),"false" == window.sessionStorage.getItem("state") ? ($("[data-inactive]").attr('style','position:absolute;left:-99999px;top:0;'), $(".toggle-inactive").prop("checked", !1)) : ($("[data-inactive]").attr('style','position:relative;left:0;top:0;'), $(".toggle-inactive").prop("checked", !0), $("section").removeClass("last")));
if(window.matchMedia("(max-width: 767px)").matches){
	$('[data-inactive]').attr('style','display:none !important;')
}
//"false" == window.sessionStorage.getItem("state") ? ($("[data-inactive]").toggleClass('d-block d-none'), $(".toggle-inactive").prop("checked", !1)) : ($("[data-inactive]").toggleClass('d-none d-block'), $(".toggle-inactive").prop("checked", !0)), $("section").removeClass("last"));
$(".floating-sidebar").length ? window.matchMedia("(max-width: 767px)").matches ? $(".floating-sidebar").addClass("last") : $("section").not(":hidden").last().addClass("last") : $("section").not(":hidden").last().addClass("last");
$('[href="javascript:expandNextSection()"],.expandNextSection').on("click", function(a) {
    a.preventDefault();
	var _this = this;
    var next;
	if($(this).closest("section").next().prop('tagName') == 'DIV'){
		 next = $(this).closest("section").next().next()
	}
	else{
		next = $(this).closest("section").next()
	}
	
	next.toggleClass("expand-section");
	
    setTimeout(function() {
        window.dispatchEvent(new Event("resize"));
		if(next.hasClass('expand-section')){
			$('html,body').animate({scrollTop: next.offset().top - 90},300);
		}
		else{
			$('html,body').animate({scrollTop: $(_this).closest("section").offset().top - 90},300);
		}
    }, 420)
	
}); 

$('.expandSideContact').on("click", function(e) {
	e.preventDefault();
	$('#sidecontact').trigger('click')	
})

/*$(window).on("resize", function() {
    setTimeout(function() {
        window.dispatchEvent(new Event("resize"))
    }, 100) 
});*/

$('[data-toggle="tab"]').on('shown.bs.tab', function (event) {
 // event.target // newly activated tab
 // event.relatedTarget // previous active tab
 window.dispatchEvent(new Event("resize"))
})

var queryString = window.location.search;
var urlParams = new URLSearchParams(queryString);
if(urlParams.has('n') && $('select[name="anzahl"]').length){
	$('select[name="anzahl"] option[value="'+urlParams.get('n')+'"]').prop('selected',true)	
}
if($('main video').length){
setTimeout(function(){
$('main video')[0].currentTime = 4.5;
},1000)
}

$('.counter-count').each(function(){
	$(this).attr('data-orig-count',$(this).text())	
})

function animateCounter(section){
	
	$('.counter-count').stop()
	$('.counter-count',section).each(function () {
		
		
		$(this).text($(this).attr('data-orig-count'))
		$(this).prop('Counter',0).animate({
			Counter: $(this).text()
		}, {
			duration: 3000,
			easing: 'swing',
			step: function (now) {
				$(this).text(Math.ceil(now));
			}
		});

	});
}

if($('.counter-count').length){
	var element = document.querySelector('.counter-count');
	var observer = new IntersectionObserver(function(entries){
	 if(entries[0].isIntersecting){
		animateCounter($(entries[0].target).closest('section'))
	 }
	 else{
		$(entries[0].target).text($(this).attr('data-orig-count')) 
	 }
	});
	
	observer.observe( element );
}



if($('[data-scrollintoviewaction]').length){
	$('section').each(function(){
		
		var element = $(this)[0];
		var observer = new IntersectionObserver(function(entries){

		 if(entries[0].isIntersecting){
			$('.bubble').fadeOut('fast');
			if(entries[0].target.hasAttribute('data-scrollintoviewaction')){
				$('.bubble[data-sec="'+$(entries[0].target).attr('id').replace('sec','')+'"]').fadeIn('fast')
			}
		 }
		
		});
		
		observer.observe( element );
		
	})
}

if ($('[data-scrollintoview]').length) {
    var elements = document.querySelectorAll('[data-scrollintoview]');
    var elIndex = new Map();
    elements.forEach(function(el, i){ elIndex.set(el, i); });

    var sivObserver = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
            var i = elIndex.get(entry.target);
            var $el = $(entry.target);
            var $img = $('.timage', entry.target);

            if (entry.isIntersecting) {
                $img.removeClass('animate__zoomOut').addClass('animate__zoomIn');
                setTimeout(function(){
                    $el.addClass('transform').attr('data-idx', i);
                }, 200);
            } else {
                $img.removeClass('animate__zoomIn').addClass('animate__zoomOut');
                $('.transform').each(function(){
                    var diff = i - parseInt($(this).attr('data-idx'), 10);
                    if (diff < -2) $(this).removeClass('transform');
                });
            }
        });
    }, { rootMargin: '-200px' });

    elements.forEach(function(el){ sivObserver.observe(el); });
}



$('.showpeakly,.closepeaklynav').on('click',function(e){
	$('#peaklynav').toggle().toggleClass('open')
	if(!$('#peaklynav').hasClass('open')){
		$('body').removeClass('peaklynav-open');	
	}
});

$('.closebigmenu').on('click',function(e){
	$('body').removeClass('subnav-open');
	$(".clicked").removeClass("clicked")	
});

var timeOutFunctionId;
function afterResize() {
	window.dispatchEvent(new Event("resizeend")) 
}

window.addEventListener("resize", function() {
	if(window.matchMedia("(min-width: 768px)").matches){
		clearTimeout(timeOutFunctionId);
		timeOutFunctionId = setTimeout(afterResize, 200);
	}
	/*$('.lead2 blockquote').each(function(i,e){
		$(this).css({display:'inline'})
		var textwidth = $(this).width();
		$('strong',this).width(textwidth)
		$(this).css({display:'block'})
	})*/
	if(window.matchMedia("(max-width: 767px)").matches){
		$('[data-inactive]').attr('style','display:none !important;')
	}
});

window.dispatchEvent(new Event("resize"))

window.addEventListener("resizeend", function() {
	0 < $(".fullheight").length && (headerheight = $(window).outerHeight() - marqheight, $(".full,.fullheight,.fullheight .swiper-slide").css({
        height: headerheight
    }));
    $(".cart > ul > li").css({
        maxHeight: "calc(100vh - " + $(".logo").height() + "px)",
        overflow: "hidden",
        overflowY: "auto"
    });
    window.matchMedia("(max-width: 767px)").matches ? $.fn.validator.Constructor.FOCUS_OFFSET = 120 : $.fn.validator.Constructor.FOCUS_OFFSET = 320;
    $(".floating-sidebar").length ? window.matchMedia("(max-width: 767px)").matches ?
        $(".floating-sidebar").addClass("last") : $("section").not(":hidden").last().addClass("last") : $("section").not(":hidden").last().addClass("last");
		//document.documentElement.style.setProperty('--viewport-height', $(window).outerHeight() + 'px'); 
		
	var $sidebar = $(".floating-sidebar:visible");
	if (!$sidebar.length) return;
	
	// ALL READS first
	var $end = $("[data-endfloatingsection]");
	var $startDiv = $("[data-startfloatingsection] > div");
	var startTop = parseInt($startDiv.offset().top, 10);
	// Ergebnis aus position()/height() wird im Original direkt überschrieben — entfällt
	// (var v / Y waren tote Berechnungen)
	
	// ALL WRITES
	$sidebar.attr("style", "top:" + startTop + "px;left:auto;");
	
	if(window.matchMedia("(max-width: 1200px)").matches){
		$('body').removeClass('subnav-open');
		$(".clicked").removeClass("clicked")	
	}
	
});

$('.mainnav .nav-item a').hover(
	function(){
		if($('img',this).attr('data-hover') != ''){
			$('img',this).attr('src',$('img',this).attr('data-hover'))
		}
	},
	function(){
		if($('img',this).attr('data-hover') != ''){
			$('img',this).attr('src',$('img',this).attr('data-orig'))
		}
	}
)

SmoothScroll({
    frameRate: 60,            // matcht typische Display-Refresh-Rate
    animationTime: 600,
    stepSize: 100,
    pulseAlgorithm: 1,
    pulseScale: 4,
    pulseNormalize: 1,
    accelerationDelta: 300,
    accelerationMax: 2,
    keyboardSupport: 1,
    arrowScroll: 50,
    fixedBackground: 0
});

/*if($('[data-service="twitter"]').length){
	$(window).resize(function(){
		$('[data-service="twitter"]').height($('.twitter-tweet.twitter-tweet-rendered').height())	
	})
}*/

$('.accordion [data-toggle="collapse"]').each(function(){
    var $card_header = $(this);
    var $collapse_element = $card_header.parent().next();
    $collapse_element.on('shown.bs.collapse', function () {
      var $card_header_top = $card_header.offset().top;
      var $visible_collapse = $('.collapse.show');
      if($visible_collapse.length){
        var $visible_collapse_top = $visible_collapse.offset().top;
        if($visible_collapse_top < $card_header_top){
          $card_header_top -= $visible_collapse.height();
        }
      }
      $([document.documentElement, document.body]).animate({
        scrollTop: $card_header_top - 94 - 30
      });
    });
});
  
AOS.init({
	// Global settings:
	disable: 'mobile', // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
	startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
	initClassName: 'aos-init', // class applied after initialization
	animatedClassName: 'aos-animate', // class applied on animation
	useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
	disableMutationObserver: false, // disables automatic mutations' detections (advanced)
	debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
	throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
});

setTimeout(function(){
	$('[data-parallax="scroll"] .dim').each(function(i,e){
		var parent = $(this).closest('[data-parallax="scroll"]').attr('id');
		$(this).appendTo('.parallax-mirror.'+parent); 
	})
},1000)

$('[data-inactive]').each(function(i,e){
	$(this).css({width:'100%'});
});

/*$.getScript('https://cdnjs.cloudflare.com/ajax/libs/animejs/2.0.2/anime.min.js',function(ret){
	var textWrapper = document.querySelector('.h1');
	textWrapper.innerHTML = textWrapper.textContent.replace(/\S/g, "<span class='letter'>$&</span>");
	
	anime.timeline({loop: false})
	  .add({
		targets: '.letter',
		scale: [4,1],
		opacity: [0,1],
		translateZ: 0,
		easing: "easeOutExpo",
		duration: 950,
		delay: (el, i) => 70*i
	  }).add({
		targets: '.h1',
		opacity: 0,
		duration: 1000,
		easing: "easeOutExpo",
		delay: 1000
	  });
})*/

